// Code generated by protoc-gen-iqwebapi. DO NOT EDIT.
// source: auth.proto

import axios from 'axios';
import StoreHash from '@/utils/StoreHash';

const initialState = {
	APIKeys: {
		UUIDs: {},
		lifetime: 3 * 60 * 1000, // 3 minutes
	},
	AuthResponses: {
		UUIDs: {},
		lifetime: 3 * 60 * 1000, // 3 minutes
	},
	AuthRoles: {
		UUIDs: {},
		lifetime: 3 * 60 * 1000, // 3 minutes
	},
	AuthRoleGroups: {
		UUIDs: {},
		lifetime: 3 * 60 * 1000, // 3 minutes
	},
	AuthRoleGroupMembers: {
		UUIDs: {},
		lifetime: 3 * 60 * 1000, // 3 minutes
	},
	Identities: {
		UUIDs: {},
		lifetime: 3 * 60 * 1000, // 3 minutes
	},
	LocalUsers: {
		UUIDs: {},
		lifetime: 3 * 60 * 1000, // 3 minutes
	},
	MultiFactorUsers: {
		UUIDs: {},
		lifetime: 3 * 60 * 1000, // 3 minutes
	},
};

const valFuncFind = function (status) {
	return (status == 200) ? true : (status == 404) ? true : false;
}

const default_pageinfo = {
	PageNumber: 0,
	PageItemCount: 0,
	TotalPages: 0,
	TotalItemCount: 0,
	IndexStart: 0,
	PageSize: 10,
	DisplayPageList: [],
	DisplayPageEitherSide: 4,
}

const getters = {
	getAPIKeyByUUID: state => (UUID) => (state.APIKeys.UUIDs[ UUID ] && !state.APIKeys.UUIDs[ UUID ].expired()) ?  state.APIKeys.UUIDs[ UUID ].hashedData() : null,
	getAuthResponseByUUID: state => (UUID) => (state.AuthResponses.UUIDs[ UUID ] && !state.AuthResponses.UUIDs[ UUID ].expired()) ?  state.AuthResponses.UUIDs[ UUID ].hashedData() : null,
	getAuthRoleByUUID: state => (UUID) => (state.AuthRoles.UUIDs[ UUID ] && !state.AuthRoles.UUIDs[ UUID ].expired()) ?  state.AuthRoles.UUIDs[ UUID ].hashedData() : null,
	getAuthRoleGroupByUUID: state => (UUID) => (state.AuthRoleGroups.UUIDs[ UUID ] && !state.AuthRoleGroups.UUIDs[ UUID ].expired()) ?  state.AuthRoleGroups.UUIDs[ UUID ].hashedData() : null,
	getAuthRoleGroupMemberByUUID: state => (UUID) => (state.AuthRoleGroupMembers.UUIDs[ UUID ] && !state.AuthRoleGroupMembers.UUIDs[ UUID ].expired()) ?  state.AuthRoleGroupMembers.UUIDs[ UUID ].hashedData() : null,
	getIdentityByUUID: state => (UUID) => (state.Identities.UUIDs[ UUID ] && !state.Identities.UUIDs[ UUID ].expired()) ?  state.Identities.UUIDs[ UUID ].hashedData() : null,
	getLocalUserByUUID: state => (UUID) => (state.LocalUsers.UUIDs[ UUID ] && !state.LocalUsers.UUIDs[ UUID ].expired()) ?  state.LocalUsers.UUIDs[ UUID ].hashedData() : null,
	getMultiFactorUserByUUID: state => (UUID) => (state.MultiFactorUsers.UUIDs[ UUID ] && !state.MultiFactorUsers.UUIDs[ UUID ].expired()) ?  state.MultiFactorUsers.UUIDs[ UUID ].hashedData() : null,
};

const mutations = {
	// mutSaveAPIKey saves a single APIKey object
	// into both the StoreHash cache and the VueX store
	mutSaveAPIKey(state, obj) {
		if (!obj.UUID) { return } // Must have UUID to Save

		if (!(obj.UUID in state.APIKeys.UUIDs)) {
			state.APIKeys.UUIDs[ obj.UUID ] = new StoreHash(state.APIKeys.lifetime)
		}
		state.APIKeys.UUIDs[ obj.UUID ].fix(obj) // Add item to StoreHash
	},
	// mutRemoveAPIKeyByUUID removes a APIKey object
	// with the given UUID from StoreHash cache and VueX store
	mutRemoveAPIKeyByUUID(state, UUID) {
		if (!UUID) {
			// Must have UUID to Remove
			return
		}
		delete state.APIKeys.UUIDs[ UUID ]    // remove item from StoreHash
	},
	// mutSaveAPIKeys saves a paginated response of APIKeys
	mutSaveAPIKeys(state, { Response }) {
		if (!Response || !Array.isArray(Response.APIKeys)) {
			// Must have Response object with results
			return
		}
		for (let i = 0; i < Response.APIKeys.length; i++) {
			if (!(Response.APIKeys[i].UUID in state.APIKeys.UUIDs)) {
				state.APIKeys.UUIDs[ Response.APIKeys[i].UUID ] = new StoreHash(state.APIKeys.lifetime)
			}
			state.APIKeys.UUIDs[ Response.APIKeys[i].UUID ].fix(Response.APIKeys[i])  // Add single APIKey to StoreHash
		}
	},
	// mutSaveAuthResponse saves a single AuthResponse object
	// into both the StoreHash cache and the VueX store
	mutSaveAuthResponse(state, obj) {
		if (!obj.UUID) { return } // Must have UUID to Save

		if (!(obj.UUID in state.AuthResponses.UUIDs)) {
			state.AuthResponses.UUIDs[ obj.UUID ] = new StoreHash(state.AuthResponses.lifetime)
		}
		state.AuthResponses.UUIDs[ obj.UUID ].fix(obj) // Add item to StoreHash
	},
	// mutRemoveAuthResponseByUUID removes a AuthResponse object
	// with the given UUID from StoreHash cache and VueX store
	mutRemoveAuthResponseByUUID(state, UUID) {
		if (!UUID) {
			// Must have UUID to Remove
			return
		}
		delete state.AuthResponses.UUIDs[ UUID ]    // remove item from StoreHash
	},
	// mutSaveAuthResponses saves a paginated response of AuthResponses
	mutSaveAuthResponses(state, { Response }) {
		if (!Response || !Array.isArray(Response.AuthResponses)) {
			// Must have Response object with results
			return
		}
		for (let i = 0; i < Response.AuthResponses.length; i++) {
			if (!(Response.AuthResponses[i].UUID in state.AuthResponses.UUIDs)) {
				state.AuthResponses.UUIDs[ Response.AuthResponses[i].UUID ] = new StoreHash(state.AuthResponses.lifetime)
			}
			state.AuthResponses.UUIDs[ Response.AuthResponses[i].UUID ].fix(Response.AuthResponses[i])  // Add single AuthResponse to StoreHash
		}
	},
	// mutSaveAuthRole saves a single AuthRole object
	// into both the StoreHash cache and the VueX store
	mutSaveAuthRole(state, obj) {
		if (!obj.UUID) { return } // Must have UUID to Save

		if (!(obj.UUID in state.AuthRoles.UUIDs)) {
			state.AuthRoles.UUIDs[ obj.UUID ] = new StoreHash(state.AuthRoles.lifetime)
		}
		state.AuthRoles.UUIDs[ obj.UUID ].fix(obj) // Add item to StoreHash
	},
	// mutRemoveAuthRoleByUUID removes a AuthRole object
	// with the given UUID from StoreHash cache and VueX store
	mutRemoveAuthRoleByUUID(state, UUID) {
		if (!UUID) {
			// Must have UUID to Remove
			return
		}
		delete state.AuthRoles.UUIDs[ UUID ]    // remove item from StoreHash
	},
	// mutSaveAuthRoles saves a paginated response of AuthRoles
	mutSaveAuthRoles(state, { Response }) {
		if (!Response || !Array.isArray(Response.AuthRoles)) {
			// Must have Response object with results
			return
		}
		for (let i = 0; i < Response.AuthRoles.length; i++) {
			if (!(Response.AuthRoles[i].UUID in state.AuthRoles.UUIDs)) {
				state.AuthRoles.UUIDs[ Response.AuthRoles[i].UUID ] = new StoreHash(state.AuthRoles.lifetime)
			}
			state.AuthRoles.UUIDs[ Response.AuthRoles[i].UUID ].fix(Response.AuthRoles[i])  // Add single AuthRole to StoreHash
		}
	},
	// mutSaveAuthRoleGroup saves a single AuthRoleGroup object
	// into both the StoreHash cache and the VueX store
	mutSaveAuthRoleGroup(state, obj) {
		if (!obj.UUID) { return } // Must have UUID to Save

		if (!(obj.UUID in state.AuthRoleGroups.UUIDs)) {
			state.AuthRoleGroups.UUIDs[ obj.UUID ] = new StoreHash(state.AuthRoleGroups.lifetime)
		}
		state.AuthRoleGroups.UUIDs[ obj.UUID ].fix(obj) // Add item to StoreHash
	},
	// mutRemoveAuthRoleGroupByUUID removes a AuthRoleGroup object
	// with the given UUID from StoreHash cache and VueX store
	mutRemoveAuthRoleGroupByUUID(state, UUID) {
		if (!UUID) {
			// Must have UUID to Remove
			return
		}
		delete state.AuthRoleGroups.UUIDs[ UUID ]    // remove item from StoreHash
	},
	// mutSaveAuthRoleGroups saves a paginated response of AuthRoleGroups
	mutSaveAuthRoleGroups(state, { Response }) {
		if (!Response || !Array.isArray(Response.AuthRoleGroups)) {
			// Must have Response object with results
			return
		}
		for (let i = 0; i < Response.AuthRoleGroups.length; i++) {
			if (!(Response.AuthRoleGroups[i].UUID in state.AuthRoleGroups.UUIDs)) {
				state.AuthRoleGroups.UUIDs[ Response.AuthRoleGroups[i].UUID ] = new StoreHash(state.AuthRoleGroups.lifetime)
			}
			state.AuthRoleGroups.UUIDs[ Response.AuthRoleGroups[i].UUID ].fix(Response.AuthRoleGroups[i])  // Add single AuthRoleGroup to StoreHash
		}
	},
	// mutSaveAuthRoleGroupMember saves a single AuthRoleGroupMember object
	// into both the StoreHash cache and the VueX store
	mutSaveAuthRoleGroupMember(state, obj) {
		if (!obj.UUID) { return } // Must have UUID to Save

		if (!(obj.UUID in state.AuthRoleGroupMembers.UUIDs)) {
			state.AuthRoleGroupMembers.UUIDs[ obj.UUID ] = new StoreHash(state.AuthRoleGroupMembers.lifetime)
		}
		state.AuthRoleGroupMembers.UUIDs[ obj.UUID ].fix(obj) // Add item to StoreHash
	},
	// mutRemoveAuthRoleGroupMemberByUUID removes a AuthRoleGroupMember object
	// with the given UUID from StoreHash cache and VueX store
	mutRemoveAuthRoleGroupMemberByUUID(state, UUID) {
		if (!UUID) {
			// Must have UUID to Remove
			return
		}
		delete state.AuthRoleGroupMembers.UUIDs[ UUID ]    // remove item from StoreHash
	},
	// mutSaveAuthRoleGroupMembers saves a paginated response of AuthRoleGroupMembers
	mutSaveAuthRoleGroupMembers(state, { Response }) {
		if (!Response || !Array.isArray(Response.AuthRoleGroupMembers)) {
			// Must have Response object with results
			return
		}
		for (let i = 0; i < Response.AuthRoleGroupMembers.length; i++) {
			if (!(Response.AuthRoleGroupMembers[i].UUID in state.AuthRoleGroupMembers.UUIDs)) {
				state.AuthRoleGroupMembers.UUIDs[ Response.AuthRoleGroupMembers[i].UUID ] = new StoreHash(state.AuthRoleGroupMembers.lifetime)
			}
			state.AuthRoleGroupMembers.UUIDs[ Response.AuthRoleGroupMembers[i].UUID ].fix(Response.AuthRoleGroupMembers[i])  // Add single AuthRoleGroupMember to StoreHash
		}
	},
	// mutSaveIdentity saves a single Identity object
	// into both the StoreHash cache and the VueX store
	mutSaveIdentity(state, obj) {
		if (!obj.UUID) { return } // Must have UUID to Save

		if (!(obj.UUID in state.Identities.UUIDs)) {
			state.Identities.UUIDs[ obj.UUID ] = new StoreHash(state.Identities.lifetime)
		}
		state.Identities.UUIDs[ obj.UUID ].fix(obj) // Add item to StoreHash
	},
	// mutRemoveIdentityByUUID removes a Identity object
	// with the given UUID from StoreHash cache and VueX store
	mutRemoveIdentityByUUID(state, UUID) {
		if (!UUID) {
			// Must have UUID to Remove
			return
		}
		delete state.Identities.UUIDs[ UUID ]    // remove item from StoreHash
	},
	// mutSaveLocalUser saves a single LocalUser object
	// into both the StoreHash cache and the VueX store
	mutSaveLocalUser(state, obj) {
		if (!obj.UUID) { return } // Must have UUID to Save

		if (!(obj.UUID in state.LocalUsers.UUIDs)) {
			state.LocalUsers.UUIDs[ obj.UUID ] = new StoreHash(state.LocalUsers.lifetime)
		}
		state.LocalUsers.UUIDs[ obj.UUID ].fix(obj) // Add item to StoreHash
	},
	// mutRemoveLocalUserByUUID removes a LocalUser object
	// with the given UUID from StoreHash cache and VueX store
	mutRemoveLocalUserByUUID(state, UUID) {
		if (!UUID) {
			// Must have UUID to Remove
			return
		}
		delete state.LocalUsers.UUIDs[ UUID ]    // remove item from StoreHash
	},
	// mutSaveMultiFactorUser saves a single MultiFactorUser object
	// into both the StoreHash cache and the VueX store
	mutSaveMultiFactorUser(state, obj) {
		if (!obj.UUID) { return } // Must have UUID to Save

		if (!(obj.UUID in state.MultiFactorUsers.UUIDs)) {
			state.MultiFactorUsers.UUIDs[ obj.UUID ] = new StoreHash(state.MultiFactorUsers.lifetime)
		}
		state.MultiFactorUsers.UUIDs[ obj.UUID ].fix(obj) // Add item to StoreHash
	},
	// mutRemoveMultiFactorUserByUUID removes a MultiFactorUser object
	// with the given UUID from StoreHash cache and VueX store
	mutRemoveMultiFactorUserByUUID(state, UUID) {
		if (!UUID) {
			// Must have UUID to Remove
			return
		}
		delete state.MultiFactorUsers.UUIDs[ UUID ]    // remove item from StoreHash
	},
	// mutSaveMultiFactorUsers saves a paginated response of MultiFactorUsers
	mutSaveMultiFactorUsers(state, { Response }) {
		if (!Response || !Array.isArray(Response.MultiFactorUsers)) {
			// Must have Response object with results
			return
		}
		for (let i = 0; i < Response.MultiFactorUsers.length; i++) {
			if (!(Response.MultiFactorUsers[i].UUID in state.MultiFactorUsers.UUIDs)) {
				state.MultiFactorUsers.UUIDs[ Response.MultiFactorUsers[i].UUID ] = new StoreHash(state.MultiFactorUsers.lifetime)
			}
			state.MultiFactorUsers.UUIDs[ Response.MultiFactorUsers[i].UUID ].fix(Response.MultiFactorUsers[i])  // Add single MultiFactorUser to StoreHash
		}
	},
};

const actions = {
	// getCachedAPIKeyByUUID fetches a APIKey from the cache
	// and if not in the cache, fetches it from the API
	getCachedAPIKeyByUUID({ state, dispatch, commit }, { UUID, RefreshCache }) {
		if (!RefreshCache && state.APIKeys.UUIDs[ UUID ] && !state.APIKeys.UUIDs[ UUID ].expired()) {
			// Return the cached record
			return state.APIKeys.UUIDs[ UUID ].hashedData()
		}
		// Fetch from the API
		return dispatch('GetAPIKeyByUUID', { UUID }).then(respPayload => {
			commit('mutSaveAPIKey', respPayload)
			return Promise.resolve(respPayload)
		}).catch(error => {
			commit('mutRemoveAPIKeyByUUID', UUID)
			return Promise.reject(error)
		})
	},

	// getCachedAuthResponseByUUID fetches a AuthResponse from the cache
	// and if not in the cache, fetches it from the API
	getCachedAuthResponseByUUID({ state, dispatch, commit }, { UUID, RefreshCache }) {
		if (!RefreshCache && state.AuthResponses.UUIDs[ UUID ] && !state.AuthResponses.UUIDs[ UUID ].expired()) {
			// Return the cached record
			return state.AuthResponses.UUIDs[ UUID ].hashedData()
		}
		// Fetch from the API
		return dispatch('GetAuthResponseByUUID', { UUID }).then(respPayload => {
			commit('mutSaveAuthResponse', respPayload)
			return Promise.resolve(respPayload)
		}).catch(error => {
			commit('mutRemoveAuthResponseByUUID', UUID)
			return Promise.reject(error)
		})
	},

	// getCachedAuthRoleByUUID fetches a AuthRole from the cache
	// and if not in the cache, fetches it from the API
	getCachedAuthRoleByUUID({ state, dispatch, commit }, { UUID, RefreshCache }) {
		if (!RefreshCache && state.AuthRoles.UUIDs[ UUID ] && !state.AuthRoles.UUIDs[ UUID ].expired()) {
			// Return the cached record
			return state.AuthRoles.UUIDs[ UUID ].hashedData()
		}
		// Fetch from the API
		return dispatch('GetAuthRoleByUUID', { UUID }).then(respPayload => {
			commit('mutSaveAuthRole', respPayload)
			return Promise.resolve(respPayload)
		}).catch(error => {
			commit('mutRemoveAuthRoleByUUID', UUID)
			return Promise.reject(error)
		})
	},

	// getCachedAuthRoleGroupByUUID fetches a AuthRoleGroup from the cache
	// and if not in the cache, fetches it from the API
	getCachedAuthRoleGroupByUUID({ state, dispatch, commit }, { UUID, RefreshCache }) {
		if (!RefreshCache && state.AuthRoleGroups.UUIDs[ UUID ] && !state.AuthRoleGroups.UUIDs[ UUID ].expired()) {
			// Return the cached record
			return state.AuthRoleGroups.UUIDs[ UUID ].hashedData()
		}
		// Fetch from the API
		return dispatch('GetAuthRoleGroupByUUID', { UUID }).then(respPayload => {
			commit('mutSaveAuthRoleGroup', respPayload)
			return Promise.resolve(respPayload)
		}).catch(error => {
			commit('mutRemoveAuthRoleGroupByUUID', UUID)
			return Promise.reject(error)
		})
	},

	// getCachedAuthRoleGroupMemberByUUID fetches a AuthRoleGroupMember from the cache
	// and if not in the cache, fetches it from the API
	getCachedAuthRoleGroupMemberByUUID({ state, dispatch, commit }, { UUID, RefreshCache }) {
		if (!RefreshCache && state.AuthRoleGroupMembers.UUIDs[ UUID ] && !state.AuthRoleGroupMembers.UUIDs[ UUID ].expired()) {
			// Return the cached record
			return state.AuthRoleGroupMembers.UUIDs[ UUID ].hashedData()
		}
		// Fetch from the API
		return dispatch('GetAuthRoleGroupMemberByUUID', { UUID }).then(respPayload => {
			commit('mutSaveAuthRoleGroupMember', respPayload)
			return Promise.resolve(respPayload)
		}).catch(error => {
			commit('mutRemoveAuthRoleGroupMemberByUUID', UUID)
			return Promise.reject(error)
		})
	},

	// getCachedIdentityByUUID fetches a Identity from the cache
	// and if not in the cache, fetches it from the API
	getCachedIdentityByUUID({ state, dispatch, commit }, { UUID, RefreshCache }) {
		if (!RefreshCache && state.Identities.UUIDs[ UUID ] && !state.Identities.UUIDs[ UUID ].expired()) {
			// Return the cached record
			return state.Identities.UUIDs[ UUID ].hashedData()
		}
		// Fetch from the API
		return dispatch('GetIdentityByUUID', { UUID }).then(respPayload => {
			commit('mutSaveIdentity', respPayload)
			return Promise.resolve(respPayload)
		}).catch(error => {
			commit('mutRemoveIdentityByUUID', UUID)
			return Promise.reject(error)
		})
	},

	// getCachedLocalUserByUUID fetches a LocalUser from the cache
	// and if not in the cache, fetches it from the API
	getCachedLocalUserByUUID({ state, dispatch, commit }, { UUID, RefreshCache }) {
		if (!RefreshCache && state.LocalUsers.UUIDs[ UUID ] && !state.LocalUsers.UUIDs[ UUID ].expired()) {
			// Return the cached record
			return state.LocalUsers.UUIDs[ UUID ].hashedData()
		}
		// Fetch from the API
		return dispatch('GetLocalUserByUUID', { UUID }).then(respPayload => {
			commit('mutSaveLocalUser', respPayload)
			return Promise.resolve(respPayload)
		}).catch(error => {
			commit('mutRemoveLocalUserByUUID', UUID)
			return Promise.reject(error)
		})
	},

	// getCachedMultiFactorUserByUUID fetches a MultiFactorUser from the cache
	// and if not in the cache, fetches it from the API
	getCachedMultiFactorUserByUUID({ state, dispatch, commit }, { UUID, RefreshCache }) {
		if (!RefreshCache && state.MultiFactorUsers.UUIDs[ UUID ] && !state.MultiFactorUsers.UUIDs[ UUID ].expired()) {
			// Return the cached record
			return state.MultiFactorUsers.UUIDs[ UUID ].hashedData()
		}
		// Fetch from the API
		return dispatch('GetMultiFactorUserByUUID', { UUID }).then(respPayload => {
			commit('mutSaveMultiFactorUser', respPayload)
			return Promise.resolve(respPayload)
		}).catch(error => {
			commit('mutRemoveMultiFactorUserByUUID', UUID)
			return Promise.reject(error)
		})
	},

	//
	// Service: AuthRPC
	// 
	/**
	* RPC Method: AddAPIKey
	* Description: Add an API Key
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth/api_key
	* @param    {APIKey} req The API payload object (APIKey)
	* @return   {APIKey} The API response object (APIKey)
	*
	* @typedef  {Object}  APIKey
	* @property {String}  UUID              
	* @property {Number}  CreatedAtNanos    When the APIKey was first created
	* @property {Number}  UpdatedAtNanos    When the APIKey was last updated
	* @property {Number}  DeletedAtNanos    When the APIKey was deleted
	* @property {Number}  SPID              Default Service Provider ID
	* @property {String}  Description       Description (Mandatory, max 80 characters)
	* @property {String}  APIKey            APIKey is auto-generated on Add
	* @property {StringSlice} Roles             List of Roles for this APIKey
	* @property {Number}  CacheSeconds      CacheSeconds
	* @property {StringSlice} PermittedCIDRs    List of CIDR range to allow for this APIKey
	* @property {Number}  ExpiredAfterNanos (optional) APIKey expiry date in nanos
	*
	*/
	AddAPIKey({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Add)
		return axios.post(`/v2/${req.SPID}/auth/api_key`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('AddAPIKey ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('AddAPIKey ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('AddAPIKey ERROR:', error)
					return Promise.reject(error)
				}
				console.log('AddAPIKey UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in AddAPIKey'))
			})
	},

	/**
	* RPC Method: AddAuthRole
	* Description: Adds a new AuthRole - Requires ADMIN role
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth_role
	* @param    {AuthRole} req The API payload object (AuthRole)
	* @return   {AuthRole} The API response object (AuthRole)
	*
	* @typedef  {Object}  AuthRole
	* @property {String}  UUID             
	* @property {Number}  SPID             SPID this role is associated with (empty if role is associated with Customer)
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {String}  CustomerUUID     CustomerUUID this role is associated with (empty if role is associated with Service Provider)
	* @property {Number}  RoleID           DEPRECATED - DO NOT USE
	* @property {Number}  CreatedAt        When this object was created
	* @property {String}  CreatedBy        Who this object was created by
	* @property {Number}  UpdatedAt        When this object was last updated
	* @property {String}  UpdatedBy        Who this object was last updated by
	* @property {Number}  DeletedAt        When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy        Who deleted this object
	* @property {Number}  CustomerSPID     CustomerSPID is the SPID of the CustomerUUID (if present in this object)
	* @property {String}  RoleName         The Role this AuthRole is associating
	*
	*/
	AddAuthRole({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Add)
		return axios.post(`/v2/${req.SPID}/auth_role`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('AddAuthRole ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('AddAuthRole ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('AddAuthRole ERROR:', error)
					return Promise.reject(error)
				}
				console.log('AddAuthRole UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in AddAuthRole'))
			})
	},

	/**
	* RPC Method: AddLocalUser
	* Description: Add a local user
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth/local_user
	* @param    {LocalUser} req The API payload object (LocalUser)
	* @return   {LocalUser} The API response object (LocalUser)
	*
	* @typedef  {Object}  LocalUser
	* @property {String}  UUID                 
	* @property {Number}  SPID                 Default Service Provider ID
	* @property {String}  Username             Authentication Identifier
	* @property {String}  Password             
	* @property {String}  FirstName            string Salt = 5 [json_name = "Salt", (tagger.tags) = "json:\"Salt\" db:\"Salt\" gorm:\"Column:Salt;NOT NULL\" bson:\"Salt\" csv:\"Salt\" query:\"Salt\" xml:\"Salt\" dynamodb:\"Salt\" datastore:\"Salt\" bigquery:\"Salt\" spanner:\"Salt\" mapstructure:\"Salt\" graphql:\"Salt\" firestore:\"Salt\"", (validator.field) = {,      length_gt: 0,      human_error: "Must have Salt",  }];,  First name of the Identity
	* @property {String}  LastName             Last name of the Identity
	* @property {String}  MobileNumber         Mobile phone number
	* @property {String}  Email                Email address
	* @property {Number}  PasswordExpiryNanos  Password expiry timestamp - triggers that password must be reset on next login
	* @property {ENUM}    PasswordExpiryStatus Why the password expired
	* @property {Number}  CreatedAtNanos       When the Local User was first created
	* @property {Number}  UpdatedAtNanos       When the Local User was last updated
	* @property {Number}  DeletedAtNanos       When the Local User was deleted
	* @property {String}  ReplacedByUUID       Which user replaced this
	*
	*/
	AddLocalUser({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Add)
		return axios.post(`/v2/${req.SPID}/auth/local_user`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('AddLocalUser ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('AddLocalUser ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('AddLocalUser ERROR:', error)
					return Promise.reject(error)
				}
				console.log('AddLocalUser UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in AddLocalUser'))
			})
	},

	/**
	* RPC Method: AddMultiFactorOnIdentity
	* Description: Add Multi Factor Auth on an identity
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth/add_mfa
	* @param    {AddMultiFactorRequest} req The API payload object (AddMultiFactorRequest)
	* @return   {AddMultiFactorResponse} The API response object (AddMultiFactorResponse)
	*
	* @typedef  {Object}  AddMultiFactorRequest
	* @property {Number}  SPID                       
	* @property {ENUM}    IdentityProvider           The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID                     Authentication Identifier
	* @property {ENUM}    MFAType                    Type of MFA to add
	* @property {String}  MobileNumber               Mobile Number (only required if MFAType is SMS)
	* @property {String}  Email                      Email (optional, for TOTP AccountName)
	* @property {Boolean} RequireCustomerAuth        Require MFA for Customer auth (required)
	* @property {Boolean} RequireServiceProviderAuth Require MFA for Service Provider auth (required)
	*
	* @typedef  {Object}  AddMultiFactorResponse
	* @property {Number}  SPID             
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {ENUM}    MFAType          Type of MFA to add
	* @property {String}  TOTPSecret       TOTP Secret (for manual entry)
	* @property {String}  TOTPQRCodeBase64 TOTP QRCode (for display), base64 encoded
	* @property {String}  TOTPIssuer       TOTP Issuer
	* @property {String}  TOTPAccountName  TOTP Account Name
	* @property {String}  MobileNumber     TOTP QRCode (for display), base64 encoded
	*
	*/
	AddMultiFactorOnIdentity({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/auth/add_mfa`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('AddMultiFactorOnIdentity ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('AddMultiFactorOnIdentity ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('AddMultiFactorOnIdentity ERROR:', error)
					return Promise.reject(error)
				}
				console.log('AddMultiFactorOnIdentity UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in AddMultiFactorOnIdentity'))
			})
	},

	/**
	* RPC Method: AddMultiFactorUser
	* Description: Add a Multi Factor User entry
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth/mfa_user
	* @param    {MultiFactorUser} req The API payload object (MultiFactorUser)
	* @return   {MultiFactorUser} The API response object (MultiFactorUser)
	*
	* @typedef  {Object}  MultiFactorUser
	* @property {String}  UUID                       
	* @property {Number}  SPID                       Default Service Provider ID
	* @property {ENUM}    IdentityProvider           The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID                     Authentication Identifier
	* @property {Number}  CreatedAtNanos             When the Local User was first created
	* @property {Number}  UpdatedAtNanos             When the Local User was last updated
	* @property {Number}  DeletedAtNanos             When the Local User was deleted
	* @property {Boolean} RequireCustomerAuth        Required for Customer Auth ?
	* @property {Boolean} RequireServiceProviderAuth Required for Service Provider Auth ?
	* @property {ENUM}    Type                       Required for Service Provider Auth ?
	* @property {Boolean} Active                     Status of the MFA (active or not active, goes active after confirmation)
	* @property {String}  TOTPSecret                 TOTP Key
	* @property {String}  MobileNumber               Mobile Number
	*
	*/
	AddMultiFactorUser({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Add)
		return axios.post(`/v2/${req.SPID}/auth/mfa_user`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('AddMultiFactorUser ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('AddMultiFactorUser ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('AddMultiFactorUser ERROR:', error)
					return Promise.reject(error)
				}
				console.log('AddMultiFactorUser UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in AddMultiFactorUser'))
			})
	},

	/**
	* RPC Method: AuthLogout
	* Description: Logout the user
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth_logout
	* @param    {LogoutRequest} req The API payload object (LogoutRequest)
	* @return   {LogoutResponse} The API response object (LogoutResponse)
	*
	* @typedef  {Object}  LogoutRequest
	* @property {Number}  SPID 
	* @property {String}  JWT  
	*
	* @typedef  {Object}  LogoutResponse
	* @property {Boolean} OK 
	*
	*/
	AuthLogout({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/auth_logout`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('AuthLogout ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('AuthLogout ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('AuthLogout ERROR:', error)
					return Promise.reject(error)
				}
				console.log('AuthLogout UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in AuthLogout'))
			})
	},

	/**
	* RPC Method: AuthSetup
	* Description: For local user, adds a new local user. For mobile user, sends a mobile confirmation code. Requires JWT
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth
	* @param    {AuthSetupRequest} req The API payload object (AuthSetupRequest)
	* @return   {AuthSetupResponse} The API response object (AuthSetupResponse)
	*
	* @typedef  {Object}  AuthSetupRequest
	* @property {Number}  SPID                 Service Provider ID
	* @property {ENUM}    IdentityProvider     The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID               Authentication Identifier
	* @property {String}  AuthCode             Authentication Code
	* @property {String}  AuthSelector         Selector (used for parallel indexing)
	* @property {Number}  LifetimeNanos        
	* @property {Boolean} OnlySendIfHasRoles   Only send this if the target Identity has roles
	* @property {Boolean} UseSmartNotification Whether or not to send a 2FA notification
	* @property {String}  Email                Email address
	* @property {String}  MobileNumber         Mobile phone number
	* @property {String}  FirstName            First name of the Identity
	* @property {String}  LastName             Last name of the Identity
	* @property {Boolean} SkipCustomerCreate   
	* @property {String}  CustomerUUID         
	*
	* @typedef  {Object}  AuthSetupResponse
	* @property {String}  UUID                    
	* @property {Number}  SPID                    Service Provider ID
	* @property {ENUM}    IdentityProvider        The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID                  Authentication Identifier
	* @property {String}  AuthCode                Authentication Code
	* @property {String}  AuthSelector            
	* @property {Number}  LifetimeNanos           
	* @property {Number}  ExpiresAtNanos          
	* @property {String}  AuthNonce               
	* @property {Number}  AuthNonceExpiresAtNanos 
	* @property {Boolean} HasRoles                Does the Identity have roles ?
	* @property {AuthRole[]} Roles                   List of Roles for this Identity (if requested in Auth request)
	* @property {String}  JWT                     
	* @property {Number}  JWTExpiry               
	* @property {String}  FirstName               First name of the Identity
	* @property {String}  LastName                Last name of the Identity
	* @property {String}  MobileNumber            Mobile phone number
	* @property {String}  Email                   Email address
	*
	*/
	AuthSetup({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/auth`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('AuthSetup ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('AuthSetup ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('AuthSetup ERROR:', error)
					return Promise.reject(error)
				}
				console.log('AuthSetup UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in AuthSetup'))
			})
	},

	/**
	* RPC Method: CheckAuth
	* Description: Checks auth or Adds a new local user
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth_check
	* @param    {AuthRequest} req The API payload object (AuthRequest)
	* @return   {AuthResponse} The API response object (AuthResponse)
	*
	* @typedef  {Object}  AuthRequest
	* @property {Number}  SPID             Service Provider ID
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {String}  AuthCode         Authentication Code
	* @property {String}  AuthSelector     
	* @property {String}  AuthNonce        
	* @property {Boolean} IncludeRoles     
	* @property {String}  MFACode          
	*
	* @typedef  {Object}  AuthResponse
	* @property {String}  UUID                        
	* @property {Number}  SPID                        Service Provider ID
	* @property {ENUM}    IdentityProvider            The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID                      Authentication Identifier
	* @property {String}  LastAuthNonce               
	* @property {Number}  AuthNonceExpiresAtNanos     
	* @property {String}  FirstName                   First name of the Identity
	* @property {String}  LastName                    Last name of the Identity
	* @property {String}  Email                       Email address
	* @property {Number}  EmailVerifiedAtNanos        
	* @property {String}  MobileNumber                Mobile phone number
	* @property {Number}  MobileNumberVerifiedAtNanos 
	* @property {AuthRole[]} Roles                       List of Roles for this Identity (if requested in Auth request)
	* @property {String}  RolesFlat                   List of Roles (CSV flattened) for this Identity (if requested in Auth request)
	* @property {String}  JWT                         
	* @property {Number}  JWTExpiry                   
	* @property {Boolean} UsedMFA                     User used MFA for auth
	*
	*/
	CheckAuth({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/auth_check`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('CheckAuth ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('CheckAuth ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('CheckAuth ERROR:', error)
					return Promise.reject(error)
				}
				console.log('CheckAuth UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in CheckAuth'))
			})
	},

	/**
	* RPC Method: ConfirmMultiFactorOnIdentity
	* Description: Confirm Multi Factor Auth on an identity
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth/confirm_mfa
	* @param    {ConfirmMultiFactorRequest} req The API payload object (ConfirmMultiFactorRequest)
	* @return   {ConfirmMultiFactorResponse} The API response object (ConfirmMultiFactorResponse)
	*
	* @typedef  {Object}  ConfirmMultiFactorRequest
	* @property {Number}  SPID             
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {ENUM}    MFAType          Type of MFA to add
	* @property {String}  MFACode          Code (TOTP or SMS)
	*
	* @typedef  {Object}  ConfirmMultiFactorResponse
	* @property {Number}  SPID             
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {Boolean} OK               Status (OK)
	*
	*/
	ConfirmMultiFactorOnIdentity({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/auth/confirm_mfa`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('ConfirmMultiFactorOnIdentity ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('ConfirmMultiFactorOnIdentity ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('ConfirmMultiFactorOnIdentity ERROR:', error)
					return Promise.reject(error)
				}
				console.log('ConfirmMultiFactorOnIdentity UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in ConfirmMultiFactorOnIdentity'))
			})
	},

	/**
	* RPC Method: DeleteAPIKeyByUUID
	* Description: Delete an API Key
	* HTTP Method: DELETE
	* API Path: /api/v2/${req.SPID}/auth/api_key/${req.UUID}
	* @param    {APIKeyUUIDSearch} req The API payload object (APIKeyUUIDSearch)
	* @return   {APIKey} The API response object (APIKey)
	*
	* @typedef  {Object}  APIKeyUUIDSearch
	* @property {String}  UUID   
	* @property {Number}  SPID   Service Provider ID - always required
	* @property {String}  APIKey 
	*
	* @typedef  {Object}  APIKey
	* @property {String}  UUID              
	* @property {Number}  CreatedAtNanos    When the APIKey was first created
	* @property {Number}  UpdatedAtNanos    When the APIKey was last updated
	* @property {Number}  DeletedAtNanos    When the APIKey was deleted
	* @property {Number}  SPID              Default Service Provider ID
	* @property {String}  Description       Description (Mandatory, max 80 characters)
	* @property {String}  APIKey            APIKey is auto-generated on Add
	* @property {StringSlice} Roles             List of Roles for this APIKey
	* @property {Number}  CacheSeconds      CacheSeconds
	* @property {StringSlice} PermittedCIDRs    List of CIDR range to allow for this APIKey
	* @property {Number}  ExpiredAfterNanos (optional) APIKey expiry date in nanos
	*
	*/
	DeleteAPIKeyByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Delete)
		return axios.delete(`/v2/${req.SPID}/auth/api_key/${req.UUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAPIKey', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('DeleteAPIKeyByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('DeleteAPIKeyByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('DeleteAPIKeyByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('DeleteAPIKeyByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in DeleteAPIKeyByUUID'))
			})
	},

	/**
	* RPC Method: DeleteLocalUserBySPIDUsername
	* Description: For a local user, remove their account. Requires JWT
	* HTTP Method: DELETE
	* API Path: /api/v2/${req.SPID}/auth/LOCAL/${req.Username}
	* @param    {LocalUserSearch} req The API payload object (LocalUserSearch)
	* @return   {LocalUser} The API response object (LocalUser)
	*
	* @typedef  {Object}  LocalUserSearch
	* @property {Number}  SPID     Service Provider ID
	* @property {String}  UUID     
	* @property {String}  Username The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc),  IdentityProvider IdentityProvider = 3 [json_name = "IdentityProvider", (tagger.tags) = "json:\"IdentityProvider\" db:\"IdentityProvider\" gorm:\"Column:IdentityProvider;NOT NULL;INDEX\" bson:\"IdentityProvider\" csv:\"IdentityProvider\" query:\"IdentityProvider\" xml:\"IdentityProvider\" dynamodb:\"IdentityProvider\" datastore:\"IdentityProvider\" bigquery:\"IdentityProvider\" spanner:\"IdentityProvider\" mapstructure:\"IdentityProvider\" graphql:\"IdentityProvider\" firestore:\"IdentityProvider\""];,  Authentication Identifier
	*
	* @typedef  {Object}  LocalUser
	* @property {String}  UUID                 
	* @property {Number}  SPID                 Default Service Provider ID
	* @property {String}  Username             Authentication Identifier
	* @property {String}  Password             
	* @property {String}  FirstName            string Salt = 5 [json_name = "Salt", (tagger.tags) = "json:\"Salt\" db:\"Salt\" gorm:\"Column:Salt;NOT NULL\" bson:\"Salt\" csv:\"Salt\" query:\"Salt\" xml:\"Salt\" dynamodb:\"Salt\" datastore:\"Salt\" bigquery:\"Salt\" spanner:\"Salt\" mapstructure:\"Salt\" graphql:\"Salt\" firestore:\"Salt\"", (validator.field) = {,      length_gt: 0,      human_error: "Must have Salt",  }];,  First name of the Identity
	* @property {String}  LastName             Last name of the Identity
	* @property {String}  MobileNumber         Mobile phone number
	* @property {String}  Email                Email address
	* @property {Number}  PasswordExpiryNanos  Password expiry timestamp - triggers that password must be reset on next login
	* @property {ENUM}    PasswordExpiryStatus Why the password expired
	* @property {Number}  CreatedAtNanos       When the Local User was first created
	* @property {Number}  UpdatedAtNanos       When the Local User was last updated
	* @property {Number}  DeletedAtNanos       When the Local User was deleted
	* @property {String}  ReplacedByUUID       Which user replaced this
	*
	*/
	DeleteLocalUserBySPIDUsername({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.delete(`/v2/${req.SPID}/auth/LOCAL/${req.Username}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('DeleteLocalUserBySPIDUsername ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('DeleteLocalUserBySPIDUsername ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('DeleteLocalUserBySPIDUsername ERROR:', error)
					return Promise.reject(error)
				}
				console.log('DeleteLocalUserBySPIDUsername UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in DeleteLocalUserBySPIDUsername'))
			})
	},

	/**
	* RPC Method: DeleteLocalUserByUUID
	* Description: For a local user, remove their account. Requires JWT
	* HTTP Method: DELETE
	* API Path: /api/v2/${req.SPID}/auth/local_user/${req.UUID}
	* @param    {LocalUserUUIDSearch} req The API payload object (LocalUserUUIDSearch)
	* @return   {LocalUser} The API response object (LocalUser)
	*
	* @typedef  {Object}  LocalUserUUIDSearch
	* @property {String}  UUID 
	* @property {Number}  SPID Service Provider ID - always required
	*
	* @typedef  {Object}  LocalUser
	* @property {String}  UUID                 
	* @property {Number}  SPID                 Default Service Provider ID
	* @property {String}  Username             Authentication Identifier
	* @property {String}  Password             
	* @property {String}  FirstName            string Salt = 5 [json_name = "Salt", (tagger.tags) = "json:\"Salt\" db:\"Salt\" gorm:\"Column:Salt;NOT NULL\" bson:\"Salt\" csv:\"Salt\" query:\"Salt\" xml:\"Salt\" dynamodb:\"Salt\" datastore:\"Salt\" bigquery:\"Salt\" spanner:\"Salt\" mapstructure:\"Salt\" graphql:\"Salt\" firestore:\"Salt\"", (validator.field) = {,      length_gt: 0,      human_error: "Must have Salt",  }];,  First name of the Identity
	* @property {String}  LastName             Last name of the Identity
	* @property {String}  MobileNumber         Mobile phone number
	* @property {String}  Email                Email address
	* @property {Number}  PasswordExpiryNanos  Password expiry timestamp - triggers that password must be reset on next login
	* @property {ENUM}    PasswordExpiryStatus Why the password expired
	* @property {Number}  CreatedAtNanos       When the Local User was first created
	* @property {Number}  UpdatedAtNanos       When the Local User was last updated
	* @property {Number}  DeletedAtNanos       When the Local User was deleted
	* @property {String}  ReplacedByUUID       Which user replaced this
	*
	*/
	DeleteLocalUserByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Delete)
		return axios.delete(`/v2/${req.SPID}/auth/local_user/${req.UUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveLocalUser', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('DeleteLocalUserByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('DeleteLocalUserByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('DeleteLocalUserByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('DeleteLocalUserByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in DeleteLocalUserByUUID'))
			})
	},

	/**
	* RPC Method: DeleteMultiFactorUserByUUID
	* Description: Delete a Multi Factor User entry
	* HTTP Method: DELETE
	* API Path: /api/v2/${req.SPID}/auth/mfa_user/${req.UUID}
	* @param    {MultiFactorUserUUIDSearch} req The API payload object (MultiFactorUserUUIDSearch)
	* @return   {MultiFactorUser} The API response object (MultiFactorUser)
	*
	* @typedef  {Object}  MultiFactorUserUUIDSearch
	* @property {String}  UUID 
	* @property {Number}  SPID Service Provider ID - always required
	*
	* @typedef  {Object}  MultiFactorUser
	* @property {String}  UUID                       
	* @property {Number}  SPID                       Default Service Provider ID
	* @property {ENUM}    IdentityProvider           The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID                     Authentication Identifier
	* @property {Number}  CreatedAtNanos             When the Local User was first created
	* @property {Number}  UpdatedAtNanos             When the Local User was last updated
	* @property {Number}  DeletedAtNanos             When the Local User was deleted
	* @property {Boolean} RequireCustomerAuth        Required for Customer Auth ?
	* @property {Boolean} RequireServiceProviderAuth Required for Service Provider Auth ?
	* @property {ENUM}    Type                       Required for Service Provider Auth ?
	* @property {Boolean} Active                     Status of the MFA (active or not active, goes active after confirmation)
	* @property {String}  TOTPSecret                 TOTP Key
	* @property {String}  MobileNumber               Mobile Number
	*
	*/
	DeleteMultiFactorUserByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Delete)
		return axios.delete(`/v2/${req.SPID}/auth/mfa_user/${req.UUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveMultiFactorUser', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('DeleteMultiFactorUserByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('DeleteMultiFactorUserByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('DeleteMultiFactorUserByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('DeleteMultiFactorUserByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in DeleteMultiFactorUserByUUID'))
			})
	},

	/**
	* RPC Method: GetAPIKeyByUUID
	* Description: Get an API Key
	* HTTP Method: GET
	* API Path: /api/v2/${req.SPID}/auth/api_key/${req.UUID}
	* @param    {APIKeyUUIDSearch} req The API payload object (APIKeyUUIDSearch)
	* @return   {APIKey} The API response object (APIKey)
	*
	* @typedef  {Object}  APIKeyUUIDSearch
	* @property {String}  UUID   
	* @property {Number}  SPID   Service Provider ID - always required
	* @property {String}  APIKey 
	*
	* @typedef  {Object}  APIKey
	* @property {String}  UUID              
	* @property {Number}  CreatedAtNanos    When the APIKey was first created
	* @property {Number}  UpdatedAtNanos    When the APIKey was last updated
	* @property {Number}  DeletedAtNanos    When the APIKey was deleted
	* @property {Number}  SPID              Default Service Provider ID
	* @property {String}  Description       Description (Mandatory, max 80 characters)
	* @property {String}  APIKey            APIKey is auto-generated on Add
	* @property {StringSlice} Roles             List of Roles for this APIKey
	* @property {Number}  CacheSeconds      CacheSeconds
	* @property {StringSlice} PermittedCIDRs    List of CIDR range to allow for this APIKey
	* @property {Number}  ExpiredAfterNanos (optional) APIKey expiry date in nanos
	*
	*/
	GetAPIKeyByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Get)
		// Prepare URI params...
		let paramSPID = encodeURIComponent(req.SPID)
		let paramUUID = encodeURIComponent(req.UUID)
		return axios.get(`/v2/${paramSPID}/auth/api_key/${paramUUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAPIKey', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetAPIKeyByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetAPIKeyByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetAPIKeyByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetAPIKeyByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetAPIKeyByUUID'))
			})
	},

	/**
	* RPC Method: GetAPIKeysPaginated
	* Description: Get a list of API Keys using search request
	* HTTP Method: GET
	* API Path: /api/v2/${req.SPID}/auth/api_key
	* @param    {APIKeySearchRequest} req The API payload object (APIKeySearchRequest)
	* @return   {APIKeyPageResponse} The API response object (APIKeyPageResponse)
	*
	* @typedef  {Object}  APIKeySearchRequest
	* @property {SearchOptions[]} SearchOptions  Search options to use (for sorting and/or pagination)
	* @property {Boolean} IncludeDeleted 
	* @property {Number}  SPID           
	* @property {String}  APIKey         
	*
	* @typedef  {Object}  SearchOptions  Search options
	* @property {Number}  PageNumber     The page number to start at (or provide IndexStart)
	* @property {Number}  PageSize       The page size
	* @property {Number}  IndexStart     The record number to start at (or provide PageNumber)
	* @property {String}  SortBy         The field to sort by
	* @property {Boolean} SortDesc       Is the sort direction descending?
	*
	* @typedef  {Object}  APIKeyPageResponse
	* @property {PageInfo} PageInfo PageInfo only needs the values ThisPageNumber && PageSize set
	* @property {APIKey[]} APIKeys  
	*
	* @typedef  {Object}   PageInfo
	* @property {Number}   PageNumber             The page number
	* @property {Number}   PageItemCount          Number of items on this page
	* @property {Number}   TotalPages             Total pages available
	* @property {Number}   TotalItemCount         Total items available
	* @property {Number}   IndexStart             The record number this search started at
	* @property {Number}   PageSize               The length of the page
	* @property {Number[]} DisplayPageList        The array of page numbers to display
	* @property {Number}   DisplayPagesEitherSide Number of pages to display either side
	*
	*/
	GetAPIKeysPaginated({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Find)
		// Prepare URI params...
		let paramSPID = encodeURIComponent(req.SPID)
		return axios.get(`/v2/${paramSPID}/auth/api_key`, { params: req, validateStatus: valFuncFind }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			commit('mutSaveAPIKeys', { Response: response.data })
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetAPIKeysPaginated ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetAPIKeysPaginated ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetAPIKeysPaginated ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetAPIKeysPaginated UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetAPIKeysPaginated'))
			})
	},

	/**
	* RPC Method: GetAuthResponsesPaginated
	* Description: Searches AuthResponses - Requires ADMIN role
	* HTTP Method: GET
	* API Path: /api/v2/${req.SPID}/auth_response
	* @param    {AuthResponseSearchRequest} req The API payload object (AuthResponseSearchRequest)
	* @return   {AuthResponsePageResponse} The API response object (AuthResponsePageResponse)
	*
	* @typedef  {Object}  AuthResponseSearchRequest
	* @property {Number}  SPID             Service Provider ID
	* @property {String}  UUID             
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {Boolean} AllowFetchAll    
	* @property {SearchOptions[]} SearchOptions    Search options to use (for sorting and/or pagination)
	*
	* @typedef  {Object}  SearchOptions  Search options
	* @property {Number}  PageNumber     The page number to start at (or provide IndexStart)
	* @property {Number}  PageSize       The page size
	* @property {Number}  IndexStart     The record number to start at (or provide PageNumber)
	* @property {String}  SortBy         The field to sort by
	* @property {Boolean} SortDesc       Is the sort direction descending?
	*
	* @typedef  {Object}  AuthResponsePageResponse
	* @property {PageInfo} PageInfo      PageInfo only needs the values ThisPageNumber && PageSize set
	* @property {AuthResponse[]} AuthResponses The list of matching AuthResponses
	*
	* @typedef  {Object}   PageInfo
	* @property {Number}   PageNumber             The page number
	* @property {Number}   PageItemCount          Number of items on this page
	* @property {Number}   TotalPages             Total pages available
	* @property {Number}   TotalItemCount         Total items available
	* @property {Number}   IndexStart             The record number this search started at
	* @property {Number}   PageSize               The length of the page
	* @property {Number[]} DisplayPageList        The array of page numbers to display
	* @property {Number}   DisplayPagesEitherSide Number of pages to display either side
	*
	*/
	GetAuthResponsesPaginated({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Find)
		// Prepare URI params...
		let paramSPID = encodeURIComponent(req.SPID)
		return axios.get(`/v2/${paramSPID}/auth_response`, { params: req, validateStatus: valFuncFind }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			commit('mutSaveAuthResponses', { Response: response.data })
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetAuthResponsesPaginated ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetAuthResponsesPaginated ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetAuthResponsesPaginated ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetAuthResponsesPaginated UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetAuthResponsesPaginated'))
			})
	},

	/**
	* RPC Method: GetAuthRolesPaginated
	* Description: Searches AuthRoles - Requires ADMIN role
	* HTTP Method: GET
	* API Path: /api/v2/${req.SPID}/auth_role
	* @param    {AuthRoleSearchRequest} req The API payload object (AuthRoleSearchRequest)
	* @return   {AuthRolePageResponse} The API response object (AuthRolePageResponse)
	*
	* @typedef  {Object}  AuthRoleSearchRequest
	* @property {String}  UUID             
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {Number}  SPID             Service Provider ID
	* @property {String}  CustomerUUID     
	* @property {Boolean} IncludeDeleted   
	* @property {Boolean} AllowFetchAll    
	* @property {SearchOptions[]} SearchOptions    Search options to use (for sorting and/or pagination)
	* @property {String}  RoleName         The Role the AuthRole is associatied with
	*
	* @typedef  {Object}  SearchOptions  Search options
	* @property {Number}  PageNumber     The page number to start at (or provide IndexStart)
	* @property {Number}  PageSize       The page size
	* @property {Number}  IndexStart     The record number to start at (or provide PageNumber)
	* @property {String}  SortBy         The field to sort by
	* @property {Boolean} SortDesc       Is the sort direction descending?
	*
	* @typedef  {Object}  AuthRolePageResponse
	* @property {PageInfo} PageInfo  PageInfo only needs the values ThisPageNumber && PageSize set
	* @property {AuthRole[]} AuthRoles The list of matching AuthRoles
	*
	* @typedef  {Object}   PageInfo
	* @property {Number}   PageNumber             The page number
	* @property {Number}   PageItemCount          Number of items on this page
	* @property {Number}   TotalPages             Total pages available
	* @property {Number}   TotalItemCount         Total items available
	* @property {Number}   IndexStart             The record number this search started at
	* @property {Number}   PageSize               The length of the page
	* @property {Number[]} DisplayPageList        The array of page numbers to display
	* @property {Number}   DisplayPagesEitherSide Number of pages to display either side
	*
	*/
	GetAuthRolesPaginated({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Find)
		// Prepare URI params...
		let paramSPID = encodeURIComponent(req.SPID)
		return axios.get(`/v2/${paramSPID}/auth_role`, { params: req, validateStatus: valFuncFind }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			commit('mutSaveAuthRoles', { Response: response.data })
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetAuthRolesPaginated ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetAuthRolesPaginated ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetAuthRolesPaginated ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetAuthRolesPaginated UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetAuthRolesPaginated'))
			})
	},

	/**
	* RPC Method: GetLocalUserBySPIDUsername
	* Description: Get a local user
	* HTTP Method: GET
	* API Path: /api/v2/${req.SPID}/auth/LOCAL/${req.Username}
	* @param    {LocalUserSearch} req The API payload object (LocalUserSearch)
	* @return   {LocalUser} The API response object (LocalUser)
	*
	* @typedef  {Object}  LocalUserSearch
	* @property {Number}  SPID     Service Provider ID
	* @property {String}  UUID     
	* @property {String}  Username The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc),  IdentityProvider IdentityProvider = 3 [json_name = "IdentityProvider", (tagger.tags) = "json:\"IdentityProvider\" db:\"IdentityProvider\" gorm:\"Column:IdentityProvider;NOT NULL;INDEX\" bson:\"IdentityProvider\" csv:\"IdentityProvider\" query:\"IdentityProvider\" xml:\"IdentityProvider\" dynamodb:\"IdentityProvider\" datastore:\"IdentityProvider\" bigquery:\"IdentityProvider\" spanner:\"IdentityProvider\" mapstructure:\"IdentityProvider\" graphql:\"IdentityProvider\" firestore:\"IdentityProvider\""];,  Authentication Identifier
	*
	* @typedef  {Object}  LocalUser
	* @property {String}  UUID                 
	* @property {Number}  SPID                 Default Service Provider ID
	* @property {String}  Username             Authentication Identifier
	* @property {String}  Password             
	* @property {String}  FirstName            string Salt = 5 [json_name = "Salt", (tagger.tags) = "json:\"Salt\" db:\"Salt\" gorm:\"Column:Salt;NOT NULL\" bson:\"Salt\" csv:\"Salt\" query:\"Salt\" xml:\"Salt\" dynamodb:\"Salt\" datastore:\"Salt\" bigquery:\"Salt\" spanner:\"Salt\" mapstructure:\"Salt\" graphql:\"Salt\" firestore:\"Salt\"", (validator.field) = {,      length_gt: 0,      human_error: "Must have Salt",  }];,  First name of the Identity
	* @property {String}  LastName             Last name of the Identity
	* @property {String}  MobileNumber         Mobile phone number
	* @property {String}  Email                Email address
	* @property {Number}  PasswordExpiryNanos  Password expiry timestamp - triggers that password must be reset on next login
	* @property {ENUM}    PasswordExpiryStatus Why the password expired
	* @property {Number}  CreatedAtNanos       When the Local User was first created
	* @property {Number}  UpdatedAtNanos       When the Local User was last updated
	* @property {Number}  DeletedAtNanos       When the Local User was deleted
	* @property {String}  ReplacedByUUID       Which user replaced this
	*
	*/
	GetLocalUserBySPIDUsername({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		// Prepare URI params...
		let paramSPID = encodeURIComponent(req.SPID)
		let paramUsername = encodeURIComponent(req.Username)
		return axios.get(`/v2/${paramSPID}/auth/LOCAL/${paramUsername}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetLocalUserBySPIDUsername ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetLocalUserBySPIDUsername ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetLocalUserBySPIDUsername ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetLocalUserBySPIDUsername UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetLocalUserBySPIDUsername'))
			})
	},

	/**
	* RPC Method: GetLocalUserByUUID
	* Description: Get a local user
	* HTTP Method: GET
	* API Path: /api/v2/${req.SPID}/auth/local_user/${req.UUID}
	* @param    {LocalUserUUIDSearch} req The API payload object (LocalUserUUIDSearch)
	* @return   {LocalUser} The API response object (LocalUser)
	*
	* @typedef  {Object}  LocalUserUUIDSearch
	* @property {String}  UUID 
	* @property {Number}  SPID Service Provider ID - always required
	*
	* @typedef  {Object}  LocalUser
	* @property {String}  UUID                 
	* @property {Number}  SPID                 Default Service Provider ID
	* @property {String}  Username             Authentication Identifier
	* @property {String}  Password             
	* @property {String}  FirstName            string Salt = 5 [json_name = "Salt", (tagger.tags) = "json:\"Salt\" db:\"Salt\" gorm:\"Column:Salt;NOT NULL\" bson:\"Salt\" csv:\"Salt\" query:\"Salt\" xml:\"Salt\" dynamodb:\"Salt\" datastore:\"Salt\" bigquery:\"Salt\" spanner:\"Salt\" mapstructure:\"Salt\" graphql:\"Salt\" firestore:\"Salt\"", (validator.field) = {,      length_gt: 0,      human_error: "Must have Salt",  }];,  First name of the Identity
	* @property {String}  LastName             Last name of the Identity
	* @property {String}  MobileNumber         Mobile phone number
	* @property {String}  Email                Email address
	* @property {Number}  PasswordExpiryNanos  Password expiry timestamp - triggers that password must be reset on next login
	* @property {ENUM}    PasswordExpiryStatus Why the password expired
	* @property {Number}  CreatedAtNanos       When the Local User was first created
	* @property {Number}  UpdatedAtNanos       When the Local User was last updated
	* @property {Number}  DeletedAtNanos       When the Local User was deleted
	* @property {String}  ReplacedByUUID       Which user replaced this
	*
	*/
	GetLocalUserByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Get)
		// Prepare URI params...
		let paramSPID = encodeURIComponent(req.SPID)
		let paramUUID = encodeURIComponent(req.UUID)
		return axios.get(`/v2/${paramSPID}/auth/local_user/${paramUUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveLocalUser', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetLocalUserByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetLocalUserByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetLocalUserByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetLocalUserByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetLocalUserByUUID'))
			})
	},

	/**
	* RPC Method: GetMultiFactorUserByUUID
	* Description: Get a Multi Factor User entry
	* HTTP Method: GET
	* API Path: /api/v2/${req.SPID}/auth/mfa_user/${req.UUID}
	* @param    {MultiFactorUserUUIDSearch} req The API payload object (MultiFactorUserUUIDSearch)
	* @return   {MultiFactorUser} The API response object (MultiFactorUser)
	*
	* @typedef  {Object}  MultiFactorUserUUIDSearch
	* @property {String}  UUID 
	* @property {Number}  SPID Service Provider ID - always required
	*
	* @typedef  {Object}  MultiFactorUser
	* @property {String}  UUID                       
	* @property {Number}  SPID                       Default Service Provider ID
	* @property {ENUM}    IdentityProvider           The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID                     Authentication Identifier
	* @property {Number}  CreatedAtNanos             When the Local User was first created
	* @property {Number}  UpdatedAtNanos             When the Local User was last updated
	* @property {Number}  DeletedAtNanos             When the Local User was deleted
	* @property {Boolean} RequireCustomerAuth        Required for Customer Auth ?
	* @property {Boolean} RequireServiceProviderAuth Required for Service Provider Auth ?
	* @property {ENUM}    Type                       Required for Service Provider Auth ?
	* @property {Boolean} Active                     Status of the MFA (active or not active, goes active after confirmation)
	* @property {String}  TOTPSecret                 TOTP Key
	* @property {String}  MobileNumber               Mobile Number
	*
	*/
	GetMultiFactorUserByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Get)
		// Prepare URI params...
		let paramSPID = encodeURIComponent(req.SPID)
		let paramUUID = encodeURIComponent(req.UUID)
		return axios.get(`/v2/${paramSPID}/auth/mfa_user/${paramUUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveMultiFactorUser', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetMultiFactorUserByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetMultiFactorUserByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetMultiFactorUserByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetMultiFactorUserByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetMultiFactorUserByUUID'))
			})
	},

	/**
	* RPC Method: GetMultiFactorUsersPaginated
	* Description: Get a list of Multi Factor User entries using search request
	* HTTP Method: GET
	* API Path: /api/v2/${req.SPID}/auth/mfa_user
	* @param    {MultiFactorUserSearchRequest} req The API payload object (MultiFactorUserSearchRequest)
	* @return   {MultiFactorUserPageResponse} The API response object (MultiFactorUserPageResponse)
	*
	* @typedef  {Object}  MultiFactorUserSearchRequest
	* @property {SearchOptions[]} SearchOptions    Search options to use (for sorting and/or pagination)
	* @property {Boolean} IncludeDeleted   
	* @property {Number}  SPID             
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	*
	* @typedef  {Object}  SearchOptions  Search options
	* @property {Number}  PageNumber     The page number to start at (or provide IndexStart)
	* @property {Number}  PageSize       The page size
	* @property {Number}  IndexStart     The record number to start at (or provide PageNumber)
	* @property {String}  SortBy         The field to sort by
	* @property {Boolean} SortDesc       Is the sort direction descending?
	*
	* @typedef  {Object}  MultiFactorUserPageResponse
	* @property {PageInfo} PageInfo         PageInfo only needs the values ThisPageNumber && PageSize set
	* @property {MultiFactorUser[]} MultiFactorUsers 
	*
	* @typedef  {Object}   PageInfo
	* @property {Number}   PageNumber             The page number
	* @property {Number}   PageItemCount          Number of items on this page
	* @property {Number}   TotalPages             Total pages available
	* @property {Number}   TotalItemCount         Total items available
	* @property {Number}   IndexStart             The record number this search started at
	* @property {Number}   PageSize               The length of the page
	* @property {Number[]} DisplayPageList        The array of page numbers to display
	* @property {Number}   DisplayPagesEitherSide Number of pages to display either side
	*
	*/
	GetMultiFactorUsersPaginated({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Find)
		// Prepare URI params...
		let paramSPID = encodeURIComponent(req.SPID)
		return axios.get(`/v2/${paramSPID}/auth/mfa_user`, { params: req, validateStatus: valFuncFind }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			commit('mutSaveMultiFactorUsers', { Response: response.data })
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetMultiFactorUsersPaginated ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetMultiFactorUsersPaginated ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetMultiFactorUsersPaginated ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetMultiFactorUsersPaginated UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetMultiFactorUsersPaginated'))
			})
	},

	/**
	* RPC Method: GrantCustomerAccess
	* Description: Grant the given Identity access to the given Customer. Requires API-Key
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/grant_customer_access
	* @param    {GrantCustomerAccessRequest} req The API payload object (GrantCustomerAccessRequest)
	* @return   {AuthResponse} The API response object (AuthResponse)
	*
	* @typedef  {Object}  GrantCustomerAccessRequest
	* @property {Number}  SPID             
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {String}  CustomerUUID     CustomerUUID to grant access to
	* @property {String}  Roles            (optional) Roles to assign, uses defaults if none provided (Defaults are in IDMSVC)
	*
	* @typedef  {Object}  AuthResponse
	* @property {String}  UUID                        
	* @property {Number}  SPID                        Service Provider ID
	* @property {ENUM}    IdentityProvider            The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID                      Authentication Identifier
	* @property {String}  LastAuthNonce               
	* @property {Number}  AuthNonceExpiresAtNanos     
	* @property {String}  FirstName                   First name of the Identity
	* @property {String}  LastName                    Last name of the Identity
	* @property {String}  Email                       Email address
	* @property {Number}  EmailVerifiedAtNanos        
	* @property {String}  MobileNumber                Mobile phone number
	* @property {Number}  MobileNumberVerifiedAtNanos 
	* @property {AuthRole[]} Roles                       List of Roles for this Identity (if requested in Auth request)
	* @property {String}  RolesFlat                   List of Roles (CSV flattened) for this Identity (if requested in Auth request)
	* @property {String}  JWT                         
	* @property {Number}  JWTExpiry                   
	* @property {Boolean} UsedMFA                     User used MFA for auth
	*
	*/
	GrantCustomerAccess({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/grant_customer_access`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GrantCustomerAccess ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GrantCustomerAccess ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GrantCustomerAccess ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GrantCustomerAccess UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GrantCustomerAccess'))
			})
	},

	/**
	* RPC Method: PurgeAPIKeyByUUID
	* Description: Purge an API Key
	* HTTP Method: DELETE
	* API Path: /api/v2/${req.SPID}/auth/api_key/${req.UUID}/purge
	* @param    {APIKeyUUIDSearch} req The API payload object (APIKeyUUIDSearch)
	* @return   {APIKey} The API response object (APIKey)
	*
	* @typedef  {Object}  APIKeyUUIDSearch
	* @property {String}  UUID   
	* @property {Number}  SPID   Service Provider ID - always required
	* @property {String}  APIKey 
	*
	* @typedef  {Object}  APIKey
	* @property {String}  UUID              
	* @property {Number}  CreatedAtNanos    When the APIKey was first created
	* @property {Number}  UpdatedAtNanos    When the APIKey was last updated
	* @property {Number}  DeletedAtNanos    When the APIKey was deleted
	* @property {Number}  SPID              Default Service Provider ID
	* @property {String}  Description       Description (Mandatory, max 80 characters)
	* @property {String}  APIKey            APIKey is auto-generated on Add
	* @property {StringSlice} Roles             List of Roles for this APIKey
	* @property {Number}  CacheSeconds      CacheSeconds
	* @property {StringSlice} PermittedCIDRs    List of CIDR range to allow for this APIKey
	* @property {Number}  ExpiredAfterNanos (optional) APIKey expiry date in nanos
	*
	*/
	PurgeAPIKeyByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Purge)
		return axios.delete(`/v2/${req.SPID}/auth/api_key/${req.UUID}/purge`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAPIKey', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('PurgeAPIKeyByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('PurgeAPIKeyByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('PurgeAPIKeyByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('PurgeAPIKeyByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in PurgeAPIKeyByUUID'))
			})
	},

	/**
	* RPC Method: PurgeLocalUserByUUID
	* Description: For a local user, remove their account. Requires JWT
	* HTTP Method: DELETE
	* API Path: /api/v2/${req.SPID}/auth/local_user/${req.UUID}/purge
	* @param    {LocalUserUUIDSearch} req The API payload object (LocalUserUUIDSearch)
	* @return   {LocalUser} The API response object (LocalUser)
	*
	* @typedef  {Object}  LocalUserUUIDSearch
	* @property {String}  UUID 
	* @property {Number}  SPID Service Provider ID - always required
	*
	* @typedef  {Object}  LocalUser
	* @property {String}  UUID                 
	* @property {Number}  SPID                 Default Service Provider ID
	* @property {String}  Username             Authentication Identifier
	* @property {String}  Password             
	* @property {String}  FirstName            string Salt = 5 [json_name = "Salt", (tagger.tags) = "json:\"Salt\" db:\"Salt\" gorm:\"Column:Salt;NOT NULL\" bson:\"Salt\" csv:\"Salt\" query:\"Salt\" xml:\"Salt\" dynamodb:\"Salt\" datastore:\"Salt\" bigquery:\"Salt\" spanner:\"Salt\" mapstructure:\"Salt\" graphql:\"Salt\" firestore:\"Salt\"", (validator.field) = {,      length_gt: 0,      human_error: "Must have Salt",  }];,  First name of the Identity
	* @property {String}  LastName             Last name of the Identity
	* @property {String}  MobileNumber         Mobile phone number
	* @property {String}  Email                Email address
	* @property {Number}  PasswordExpiryNanos  Password expiry timestamp - triggers that password must be reset on next login
	* @property {ENUM}    PasswordExpiryStatus Why the password expired
	* @property {Number}  CreatedAtNanos       When the Local User was first created
	* @property {Number}  UpdatedAtNanos       When the Local User was last updated
	* @property {Number}  DeletedAtNanos       When the Local User was deleted
	* @property {String}  ReplacedByUUID       Which user replaced this
	*
	*/
	PurgeLocalUserByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Purge)
		return axios.delete(`/v2/${req.SPID}/auth/local_user/${req.UUID}/purge`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveLocalUser', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('PurgeLocalUserByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('PurgeLocalUserByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('PurgeLocalUserByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('PurgeLocalUserByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in PurgeLocalUserByUUID'))
			})
	},

	/**
	* RPC Method: PurgeMultiFactorUserByUUID
	* Description: Purge a Multi Factor User entry
	* HTTP Method: DELETE
	* API Path: /api/v2/${req.SPID}/auth/mfa_user/${req.UUID}/purge
	* @param    {MultiFactorUserUUIDSearch} req The API payload object (MultiFactorUserUUIDSearch)
	* @return   {MultiFactorUser} The API response object (MultiFactorUser)
	*
	* @typedef  {Object}  MultiFactorUserUUIDSearch
	* @property {String}  UUID 
	* @property {Number}  SPID Service Provider ID - always required
	*
	* @typedef  {Object}  MultiFactorUser
	* @property {String}  UUID                       
	* @property {Number}  SPID                       Default Service Provider ID
	* @property {ENUM}    IdentityProvider           The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID                     Authentication Identifier
	* @property {Number}  CreatedAtNanos             When the Local User was first created
	* @property {Number}  UpdatedAtNanos             When the Local User was last updated
	* @property {Number}  DeletedAtNanos             When the Local User was deleted
	* @property {Boolean} RequireCustomerAuth        Required for Customer Auth ?
	* @property {Boolean} RequireServiceProviderAuth Required for Service Provider Auth ?
	* @property {ENUM}    Type                       Required for Service Provider Auth ?
	* @property {Boolean} Active                     Status of the MFA (active or not active, goes active after confirmation)
	* @property {String}  TOTPSecret                 TOTP Key
	* @property {String}  MobileNumber               Mobile Number
	*
	*/
	PurgeMultiFactorUserByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Purge)
		return axios.delete(`/v2/${req.SPID}/auth/mfa_user/${req.UUID}/purge`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveMultiFactorUser', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('PurgeMultiFactorUserByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('PurgeMultiFactorUserByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('PurgeMultiFactorUserByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('PurgeMultiFactorUserByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in PurgeMultiFactorUserByUUID'))
			})
	},

	/**
	* RPC Method: RemoveAuthRole
	* Description: Deletes an AuthRole - Requires ADMIN role
	* HTTP Method: DELETE
	* API Path: /api/v2/${req.SPID}/auth_role/${req.UUID}
	* @param    {AuthRole} req The API payload object (AuthRole)
	* @return   {AuthRole} The API response object (AuthRole)
	*
	* @typedef  {Object}  AuthRole
	* @property {String}  UUID             
	* @property {Number}  SPID             SPID this role is associated with (empty if role is associated with Customer)
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {String}  CustomerUUID     CustomerUUID this role is associated with (empty if role is associated with Service Provider)
	* @property {Number}  RoleID           DEPRECATED - DO NOT USE
	* @property {Number}  CreatedAt        When this object was created
	* @property {String}  CreatedBy        Who this object was created by
	* @property {Number}  UpdatedAt        When this object was last updated
	* @property {String}  UpdatedBy        Who this object was last updated by
	* @property {Number}  DeletedAt        When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy        Who deleted this object
	* @property {Number}  CustomerSPID     CustomerSPID is the SPID of the CustomerUUID (if present in this object)
	* @property {String}  RoleName         The Role this AuthRole is associating
	*
	*/
	RemoveAuthRole({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.delete(`/v2/${req.SPID}/auth_role/${req.UUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('RemoveAuthRole ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('RemoveAuthRole ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('RemoveAuthRole ERROR:', error)
					return Promise.reject(error)
				}
				console.log('RemoveAuthRole UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in RemoveAuthRole'))
			})
	},

	/**
	* RPC Method: RemoveMultiFactorOnIdentity
	* Description: Remove Multi Factor Auth from an identity
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth/remove_mfa
	* @param    {ConfirmMultiFactorRequest} req The API payload object (ConfirmMultiFactorRequest)
	* @return   {ConfirmMultiFactorResponse} The API response object (ConfirmMultiFactorResponse)
	*
	* @typedef  {Object}  ConfirmMultiFactorRequest
	* @property {Number}  SPID             
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {ENUM}    MFAType          Type of MFA to add
	* @property {String}  MFACode          Code (TOTP or SMS)
	*
	* @typedef  {Object}  ConfirmMultiFactorResponse
	* @property {Number}  SPID             
	* @property {ENUM}    IdentityProvider The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID           Authentication Identifier
	* @property {Boolean} OK               Status (OK)
	*
	*/
	RemoveMultiFactorOnIdentity({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/auth/remove_mfa`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('RemoveMultiFactorOnIdentity ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('RemoveMultiFactorOnIdentity ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('RemoveMultiFactorOnIdentity ERROR:', error)
					return Promise.reject(error)
				}
				console.log('RemoveMultiFactorOnIdentity UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in RemoveMultiFactorOnIdentity'))
			})
	},

	/**
	* RPC Method: ResetPasswordStep1LocalUser
	* Description: Sends a reset password email for a local user
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth/reset_step1/LOCAL
	* @param    {ResetRequest} req The API payload object (ResetRequest)
	* @return   {ResetResponse} The API response object (ResetResponse)
	*
	* @typedef  {Object}  ResetRequest
	* @property {Number}  SPID         Service Provider ID
	* @property {String}  UUID         LocalUser UUID
	* @property {String}  Username     LocalUser Authentication Identifier (username)
	* @property {String}  Email        LocalUser Email
	* @property {String}  MobileNumber LocalUser MobileNumber
	* @property {String}  Token        Token
	* @property {String}  NewPassword  NewPassword
	* @property {String}  RedirHost    RedirHost
	* @property {String}  RedirPath    RedirPath
	* @property {String}  OldPassword  OldPassword
	*
	* @typedef  {Object}  ResetResponse
	* @property {String}  Status 
	*
	*/
	ResetPasswordStep1LocalUser({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/auth/reset_step1/LOCAL`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('ResetPasswordStep1LocalUser ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('ResetPasswordStep1LocalUser ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('ResetPasswordStep1LocalUser ERROR:', error)
					return Promise.reject(error)
				}
				console.log('ResetPasswordStep1LocalUser UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in ResetPasswordStep1LocalUser'))
			})
	},

	/**
	* RPC Method: ResetPasswordStep2LocalUser
	* Description: Validates the link given from Step 1
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth/reset_step2/LOCAL
	* @param    {ResetRequest} req The API payload object (ResetRequest)
	* @return   {ResetResponse} The API response object (ResetResponse)
	*
	* @typedef  {Object}  ResetRequest
	* @property {Number}  SPID         Service Provider ID
	* @property {String}  UUID         LocalUser UUID
	* @property {String}  Username     LocalUser Authentication Identifier (username)
	* @property {String}  Email        LocalUser Email
	* @property {String}  MobileNumber LocalUser MobileNumber
	* @property {String}  Token        Token
	* @property {String}  NewPassword  NewPassword
	* @property {String}  RedirHost    RedirHost
	* @property {String}  RedirPath    RedirPath
	* @property {String}  OldPassword  OldPassword
	*
	* @typedef  {Object}  ResetResponse
	* @property {String}  Status 
	*
	*/
	ResetPasswordStep2LocalUser({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/auth/reset_step2/LOCAL`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('ResetPasswordStep2LocalUser ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('ResetPasswordStep2LocalUser ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('ResetPasswordStep2LocalUser ERROR:', error)
					return Promise.reject(error)
				}
				console.log('ResetPasswordStep2LocalUser UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in ResetPasswordStep2LocalUser'))
			})
	},

	/**
	* RPC Method: ResetPasswordStep3LocalUser
	* Description: Resets the password for a local user, using the token from Step 1 or their existing password
	* HTTP Method: POST
	* API Path: /api/v2/${req.SPID}/auth/reset_step3/LOCAL
	* @param    {ResetRequest} req The API payload object (ResetRequest)
	* @return   {ResetResponse} The API response object (ResetResponse)
	*
	* @typedef  {Object}  ResetRequest
	* @property {Number}  SPID         Service Provider ID
	* @property {String}  UUID         LocalUser UUID
	* @property {String}  Username     LocalUser Authentication Identifier (username)
	* @property {String}  Email        LocalUser Email
	* @property {String}  MobileNumber LocalUser MobileNumber
	* @property {String}  Token        Token
	* @property {String}  NewPassword  NewPassword
	* @property {String}  RedirHost    RedirHost
	* @property {String}  RedirPath    RedirPath
	* @property {String}  OldPassword  OldPassword
	*
	* @typedef  {Object}  ResetResponse
	* @property {String}  Status 
	*
	*/
	ResetPasswordStep3LocalUser({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.post(`/v2/${req.SPID}/auth/reset_step3/LOCAL`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('ResetPasswordStep3LocalUser ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('ResetPasswordStep3LocalUser ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('ResetPasswordStep3LocalUser ERROR:', error)
					return Promise.reject(error)
				}
				console.log('ResetPasswordStep3LocalUser UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in ResetPasswordStep3LocalUser'))
			})
	},

	/**
	* RPC Method: UpdateAPIKey
	* Description: Update API Key roles
	* HTTP Method: PUT
	* API Path: /api/v2/${req.SPID}/auth/api_key/${req.UUID}
	* @param    {APIKey} req The API payload object (APIKey)
	* @return   {APIKey} The API response object (APIKey)
	*
	* @typedef  {Object}  APIKey
	* @property {String}  UUID              
	* @property {Number}  CreatedAtNanos    When the APIKey was first created
	* @property {Number}  UpdatedAtNanos    When the APIKey was last updated
	* @property {Number}  DeletedAtNanos    When the APIKey was deleted
	* @property {Number}  SPID              Default Service Provider ID
	* @property {String}  Description       Description (Mandatory, max 80 characters)
	* @property {String}  APIKey            APIKey is auto-generated on Add
	* @property {StringSlice} Roles             List of Roles for this APIKey
	* @property {Number}  CacheSeconds      CacheSeconds
	* @property {StringSlice} PermittedCIDRs    List of CIDR range to allow for this APIKey
	* @property {Number}  ExpiredAfterNanos (optional) APIKey expiry date in nanos
	*
	*/
	UpdateAPIKey({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Update)
		return axios.put(`/v2/${req.SPID}/auth/api_key/${req.UUID}`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAPIKey', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('UpdateAPIKey ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('UpdateAPIKey ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('UpdateAPIKey ERROR:', error)
					return Promise.reject(error)
				}
				console.log('UpdateAPIKey UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in UpdateAPIKey'))
			})
	},

	/**
	* RPC Method: UpdateLocalUser
	* Description: For a local user, updates their password. Requires SP JWT
	* HTTP Method: PUT
	* API Path: /api/v2/${req.SPID}/auth/local_user/${req.UUID}
	* @param    {LocalUser} req The API payload object (LocalUser)
	* @return   {LocalUser} The API response object (LocalUser)
	*
	* @typedef  {Object}  LocalUser
	* @property {String}  UUID                 
	* @property {Number}  SPID                 Default Service Provider ID
	* @property {String}  Username             Authentication Identifier
	* @property {String}  Password             
	* @property {String}  FirstName            string Salt = 5 [json_name = "Salt", (tagger.tags) = "json:\"Salt\" db:\"Salt\" gorm:\"Column:Salt;NOT NULL\" bson:\"Salt\" csv:\"Salt\" query:\"Salt\" xml:\"Salt\" dynamodb:\"Salt\" datastore:\"Salt\" bigquery:\"Salt\" spanner:\"Salt\" mapstructure:\"Salt\" graphql:\"Salt\" firestore:\"Salt\"", (validator.field) = {,      length_gt: 0,      human_error: "Must have Salt",  }];,  First name of the Identity
	* @property {String}  LastName             Last name of the Identity
	* @property {String}  MobileNumber         Mobile phone number
	* @property {String}  Email                Email address
	* @property {Number}  PasswordExpiryNanos  Password expiry timestamp - triggers that password must be reset on next login
	* @property {ENUM}    PasswordExpiryStatus Why the password expired
	* @property {Number}  CreatedAtNanos       When the Local User was first created
	* @property {Number}  UpdatedAtNanos       When the Local User was last updated
	* @property {Number}  DeletedAtNanos       When the Local User was deleted
	* @property {String}  ReplacedByUUID       Which user replaced this
	*
	*/
	UpdateLocalUser({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Update)
		return axios.put(`/v2/${req.SPID}/auth/local_user/${req.UUID}`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveLocalUser', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('UpdateLocalUser ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('UpdateLocalUser ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('UpdateLocalUser ERROR:', error)
					return Promise.reject(error)
				}
				console.log('UpdateLocalUser UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in UpdateLocalUser'))
			})
	},

	/**
	* RPC Method: UpdateLocalUserBySPIDUsername
	* Description: For a local user, updates their password. Requires SP JWT
	* HTTP Method: PUT
	* API Path: /api/v2/${req.SPID}/auth/LOCAL/${req.Username}
	* @param    {LocalUser} req The API payload object (LocalUser)
	* @return   {LocalUser} The API response object (LocalUser)
	*
	* @typedef  {Object}  LocalUser
	* @property {String}  UUID                 
	* @property {Number}  SPID                 Default Service Provider ID
	* @property {String}  Username             Authentication Identifier
	* @property {String}  Password             
	* @property {String}  FirstName            string Salt = 5 [json_name = "Salt", (tagger.tags) = "json:\"Salt\" db:\"Salt\" gorm:\"Column:Salt;NOT NULL\" bson:\"Salt\" csv:\"Salt\" query:\"Salt\" xml:\"Salt\" dynamodb:\"Salt\" datastore:\"Salt\" bigquery:\"Salt\" spanner:\"Salt\" mapstructure:\"Salt\" graphql:\"Salt\" firestore:\"Salt\"", (validator.field) = {,      length_gt: 0,      human_error: "Must have Salt",  }];,  First name of the Identity
	* @property {String}  LastName             Last name of the Identity
	* @property {String}  MobileNumber         Mobile phone number
	* @property {String}  Email                Email address
	* @property {Number}  PasswordExpiryNanos  Password expiry timestamp - triggers that password must be reset on next login
	* @property {ENUM}    PasswordExpiryStatus Why the password expired
	* @property {Number}  CreatedAtNanos       When the Local User was first created
	* @property {Number}  UpdatedAtNanos       When the Local User was last updated
	* @property {Number}  DeletedAtNanos       When the Local User was deleted
	* @property {String}  ReplacedByUUID       Which user replaced this
	*
	*/
	UpdateLocalUserBySPIDUsername({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.put(`/v2/${req.SPID}/auth/LOCAL/${req.Username}`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('UpdateLocalUserBySPIDUsername ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('UpdateLocalUserBySPIDUsername ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('UpdateLocalUserBySPIDUsername ERROR:', error)
					return Promise.reject(error)
				}
				console.log('UpdateLocalUserBySPIDUsername UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in UpdateLocalUserBySPIDUsername'))
			})
	},

	/**
	* RPC Method: UpdateMultiFactorUser
	* Description: Update Multi Factor User entry
	* HTTP Method: PUT
	* API Path: /api/v2/${req.SPID}/auth/mfa_user/${req.UUID}
	* @param    {MultiFactorUser} req The API payload object (MultiFactorUser)
	* @return   {MultiFactorUser} The API response object (MultiFactorUser)
	*
	* @typedef  {Object}  MultiFactorUser
	* @property {String}  UUID                       
	* @property {Number}  SPID                       Default Service Provider ID
	* @property {ENUM}    IdentityProvider           The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID                     Authentication Identifier
	* @property {Number}  CreatedAtNanos             When the Local User was first created
	* @property {Number}  UpdatedAtNanos             When the Local User was last updated
	* @property {Number}  DeletedAtNanos             When the Local User was deleted
	* @property {Boolean} RequireCustomerAuth        Required for Customer Auth ?
	* @property {Boolean} RequireServiceProviderAuth Required for Service Provider Auth ?
	* @property {ENUM}    Type                       Required for Service Provider Auth ?
	* @property {Boolean} Active                     Status of the MFA (active or not active, goes active after confirmation)
	* @property {String}  TOTPSecret                 TOTP Key
	* @property {String}  MobileNumber               Mobile Number
	*
	*/
	UpdateMultiFactorUser({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Update)
		return axios.put(`/v2/${req.SPID}/auth/mfa_user/${req.UUID}`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveMultiFactorUser', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('UpdateMultiFactorUser ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('UpdateMultiFactorUser ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('UpdateMultiFactorUser ERROR:', error)
					return Promise.reject(error)
				}
				console.log('UpdateMultiFactorUser UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in UpdateMultiFactorUser'))
			})
	},

	//
	// Service: RBACRPC
	// 
	/**
	* RPC Method: AddAuthRoleGroup
	* Description: 
	* HTTP Method: POST
	* API Path: /api/v3/auth_role_group
	* @param    {AuthRoleGroup} req The API payload object (AuthRoleGroup)
	* @return   {AuthRoleGroup} The API response object (AuthRoleGroup)
	*
	* @typedef  {Object}  AuthRoleGroup
	* @property {String}  UUID           
	* @property {Number}  SPID           Service Provider ID
	* @property {String}  Name           Name of this Role Group (editable by Service Provider user admin)
	* @property {StringSlice} Roles          List of Roles for this AuthRoleGroup
	* @property {Number}  CreatedAtNanos When this object was created
	* @property {String}  CreatedBy      Who this object was created by
	* @property {Number}  UpdatedAtNanos When this object was last updated
	* @property {String}  UpdatedBy      Who this object was last updated by
	* @property {Number}  DeletedAtNanos When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy      Who deleted this object
	*
	*/
	AddAuthRoleGroup({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Add)
		return axios.post(`/v3/auth_role_group`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('AddAuthRoleGroup ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('AddAuthRoleGroup ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('AddAuthRoleGroup ERROR:', error)
					return Promise.reject(error)
				}
				console.log('AddAuthRoleGroup UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in AddAuthRoleGroup'))
			})
	},

	/**
	* RPC Method: AddAuthRoleGroupMember
	* Description: 
	* HTTP Method: POST
	* API Path: /api/v3/auth_role_group/${req.AuthRoleGroupUUID}/auth_role_group_member
	* @param    {AuthRoleGroupMember} req The API payload object (AuthRoleGroupMember)
	* @return   {AuthRoleGroupMember} The API response object (AuthRoleGroupMember)
	*
	* @typedef  {Object}  AuthRoleGroupMember
	* @property {String}  UUID              
	* @property {Number}  SPID              Service Provider ID
	* @property {String}  AuthRoleGroupUUID UUID of the AuthRole group
	* @property {ENUM}    IdentityProvider  The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID            Authentication Identifier
	* @property {Number}  CreatedAtNanos    When this object was created
	* @property {String}  CreatedBy         Who this object was created by
	* @property {Number}  UpdatedAtNanos    When this object was last updated
	* @property {String}  UpdatedBy         Who this object was last updated by
	* @property {Number}  DeletedAtNanos    When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy         Who deleted this object
	* @property {String}  DisplayName       
	*
	*/
	AddAuthRoleGroupMember({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Add)
		return axios.post(`/v3/auth_role_group/${req.AuthRoleGroupUUID}/auth_role_group_member`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('AddAuthRoleGroupMember ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('AddAuthRoleGroupMember ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('AddAuthRoleGroupMember ERROR:', error)
					return Promise.reject(error)
				}
				console.log('AddAuthRoleGroupMember UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in AddAuthRoleGroupMember'))
			})
	},

	/**
	* RPC Method: DeleteAuthRoleGroup
	* Description: 
	* HTTP Method: DELETE
	* API Path: /api/v3/auth_role_group/${req.UUID}
	* @param    {AuthRoleGroupUUIDSearch} req The API payload object (AuthRoleGroupUUIDSearch)
	* @return   {AuthRoleGroup} The API response object (AuthRoleGroup)
	*
	* @typedef  {Object}  AuthRoleGroupUUIDSearch
	* @property {String}  UUID // Service Provider ID,  int32 SPID = 1 [(tagger.tags) = "json:\"SPID\" db:\"SPID\" gorm:\"Column:SPID;NOT NULL\" bson:\"SPID\" csv:\"SPID\" query:\"SPID\" xml:\"SPID\" dynamodb:\"SPID\" datastore:\"SPID\" bigquery:\"SPID\" spanner:\"SPID\" mapstructure:\"SPID\" graphql:\"SPID\" firestore:\"SPID\"", (validator.field) = {,      int_gt: 0,      human_error: "SPID must be greater than zero",  }];
	*
	* @typedef  {Object}  AuthRoleGroup
	* @property {String}  UUID           
	* @property {Number}  SPID           Service Provider ID
	* @property {String}  Name           Name of this Role Group (editable by Service Provider user admin)
	* @property {StringSlice} Roles          List of Roles for this AuthRoleGroup
	* @property {Number}  CreatedAtNanos When this object was created
	* @property {String}  CreatedBy      Who this object was created by
	* @property {Number}  UpdatedAtNanos When this object was last updated
	* @property {String}  UpdatedBy      Who this object was last updated by
	* @property {Number}  DeletedAtNanos When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy      Who deleted this object
	*
	*/
	DeleteAuthRoleGroup({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Delete)
		return axios.delete(`/v3/auth_role_group/${req.UUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAuthRoleGroup', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('DeleteAuthRoleGroup ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('DeleteAuthRoleGroup ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('DeleteAuthRoleGroup ERROR:', error)
					return Promise.reject(error)
				}
				console.log('DeleteAuthRoleGroup UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in DeleteAuthRoleGroup'))
			})
	},

	/**
	* RPC Method: DeleteAuthRoleGroupMember
	* Description: 
	* HTTP Method: DELETE
	* API Path: /api/v3/auth_role_group/${req.AuthRoleGroupUUID}/auth_role_group_member/${req.UUID}
	* @param    {AuthRoleGroupMemberUUIDSearch} req The API payload object (AuthRoleGroupMemberUUIDSearch)
	* @return   {AuthRoleGroupMember} The API response object (AuthRoleGroupMember)
	*
	* @typedef  {Object}  AuthRoleGroupMemberUUIDSearch
	* @property {Number}  SPID              Service Provider ID
	* @property {String}  AuthRoleGroupUUID 
	* @property {String}  UUID              
	*
	* @typedef  {Object}  AuthRoleGroupMember
	* @property {String}  UUID              
	* @property {Number}  SPID              Service Provider ID
	* @property {String}  AuthRoleGroupUUID UUID of the AuthRole group
	* @property {ENUM}    IdentityProvider  The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID            Authentication Identifier
	* @property {Number}  CreatedAtNanos    When this object was created
	* @property {String}  CreatedBy         Who this object was created by
	* @property {Number}  UpdatedAtNanos    When this object was last updated
	* @property {String}  UpdatedBy         Who this object was last updated by
	* @property {Number}  DeletedAtNanos    When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy         Who deleted this object
	* @property {String}  DisplayName       
	*
	*/
	DeleteAuthRoleGroupMember({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Delete)
		return axios.delete(`/v3/auth_role_group/${req.AuthRoleGroupUUID}/auth_role_group_member/${req.UUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAuthRoleGroupMember', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('DeleteAuthRoleGroupMember ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('DeleteAuthRoleGroupMember ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('DeleteAuthRoleGroupMember ERROR:', error)
					return Promise.reject(error)
				}
				console.log('DeleteAuthRoleGroupMember UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in DeleteAuthRoleGroupMember'))
			})
	},

	/**
	* RPC Method: FindAuthRoleGroupMembersPaginated
	* Description: 
	* HTTP Method: GET
	* API Path: /api/v3/auth_role_group/${req.AuthRoleGroupUUID}/auth_role_group_member
	* @param    {AuthRoleGroupMemberSearchRequest} req The API payload object (AuthRoleGroupMemberSearchRequest)
	* @return   {AuthRoleGroupMemberPageResponse} The API response object (AuthRoleGroupMemberPageResponse)
	*
	* @typedef  {Object}  AuthRoleGroupMemberSearchRequest
	* @property {SearchOptions[]} SearchOptions     
	* @property {Number}  SPID              Service Provider ID
	* @property {Boolean} IncludeDeleted    
	* @property {String}  AuthRoleGroupUUID UUID of the AuthRole group
	* @property {ENUM}    IdentityProvider  The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID            
	*
	* @typedef  {Object}  SearchOptions  Search options
	* @property {Number}  PageNumber     The page number to start at (or provide IndexStart)
	* @property {Number}  PageSize       The page size
	* @property {Number}  IndexStart     The record number to start at (or provide PageNumber)
	* @property {String}  SortBy         The field to sort by
	* @property {Boolean} SortDesc       Is the sort direction descending?
	*
	* @typedef  {Object}  AuthRoleGroupMemberPageResponse
	* @property {PageInfo} PageInfo             PageInfo only needs the values ThisPageNumber && PageSize set
	* @property {AuthRoleGroupMember[]} AuthRoleGroupMembers 
	*
	* @typedef  {Object}   PageInfo
	* @property {Number}   PageNumber             The page number
	* @property {Number}   PageItemCount          Number of items on this page
	* @property {Number}   TotalPages             Total pages available
	* @property {Number}   TotalItemCount         Total items available
	* @property {Number}   IndexStart             The record number this search started at
	* @property {Number}   PageSize               The length of the page
	* @property {Number[]} DisplayPageList        The array of page numbers to display
	* @property {Number}   DisplayPagesEitherSide Number of pages to display either side
	*
	*/
	FindAuthRoleGroupMembersPaginated({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Find)
		// Prepare URI params...
		let paramAuthRoleGroupUUID = encodeURIComponent(req.AuthRoleGroupUUID)
		return axios.get(`/v3/auth_role_group/${paramAuthRoleGroupUUID}/auth_role_group_member`, { params: req, validateStatus: valFuncFind }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			commit('mutSaveAuthRoleGroupMembers', { Response: response.data })
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('FindAuthRoleGroupMembersPaginated ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('FindAuthRoleGroupMembersPaginated ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('FindAuthRoleGroupMembersPaginated ERROR:', error)
					return Promise.reject(error)
				}
				console.log('FindAuthRoleGroupMembersPaginated UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in FindAuthRoleGroupMembersPaginated'))
			})
	},

	/**
	* RPC Method: FindAuthRoleGroupsPaginated
	* Description: 
	* HTTP Method: GET
	* API Path: /api/v3/auth_role_group
	* @param    {AuthRoleGroupSearchRequest} req The API payload object (AuthRoleGroupSearchRequest)
	* @return   {AuthRoleGroupPageResponse} The API response object (AuthRoleGroupPageResponse)
	*
	* @typedef  {Object}  AuthRoleGroupSearchRequest
	* @property {SearchOptions[]} SearchOptions  
	* @property {Number}  SPID           Service Provider ID
	* @property {Boolean} IncludeDeleted 
	* @property {String}  Name           
	*
	* @typedef  {Object}  SearchOptions  Search options
	* @property {Number}  PageNumber     The page number to start at (or provide IndexStart)
	* @property {Number}  PageSize       The page size
	* @property {Number}  IndexStart     The record number to start at (or provide PageNumber)
	* @property {String}  SortBy         The field to sort by
	* @property {Boolean} SortDesc       Is the sort direction descending?
	*
	* @typedef  {Object}  AuthRoleGroupPageResponse
	* @property {PageInfo} PageInfo       PageInfo only needs the values ThisPageNumber && PageSize set
	* @property {AuthRoleGroup[]} AuthRoleGroups 
	*
	* @typedef  {Object}   PageInfo
	* @property {Number}   PageNumber             The page number
	* @property {Number}   PageItemCount          Number of items on this page
	* @property {Number}   TotalPages             Total pages available
	* @property {Number}   TotalItemCount         Total items available
	* @property {Number}   IndexStart             The record number this search started at
	* @property {Number}   PageSize               The length of the page
	* @property {Number[]} DisplayPageList        The array of page numbers to display
	* @property {Number}   DisplayPagesEitherSide Number of pages to display either side
	*
	*/
	FindAuthRoleGroupsPaginated({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Find)
		return axios.get(`/v3/auth_role_group`, { params: req, validateStatus: valFuncFind }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			commit('mutSaveAuthRoleGroups', { Response: response.data })
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('FindAuthRoleGroupsPaginated ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('FindAuthRoleGroupsPaginated ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('FindAuthRoleGroupsPaginated ERROR:', error)
					return Promise.reject(error)
				}
				console.log('FindAuthRoleGroupsPaginated UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in FindAuthRoleGroupsPaginated'))
			})
	},

	/**
	* RPC Method: GetAuthRoleGroupByUUID
	* Description: 
	* HTTP Method: GET
	* API Path: /api/v3/auth_role_group/${req.UUID}
	* @param    {AuthRoleGroupUUIDSearch} req The API payload object (AuthRoleGroupUUIDSearch)
	* @return   {AuthRoleGroup} The API response object (AuthRoleGroup)
	*
	* @typedef  {Object}  AuthRoleGroupUUIDSearch
	* @property {String}  UUID // Service Provider ID,  int32 SPID = 1 [(tagger.tags) = "json:\"SPID\" db:\"SPID\" gorm:\"Column:SPID;NOT NULL\" bson:\"SPID\" csv:\"SPID\" query:\"SPID\" xml:\"SPID\" dynamodb:\"SPID\" datastore:\"SPID\" bigquery:\"SPID\" spanner:\"SPID\" mapstructure:\"SPID\" graphql:\"SPID\" firestore:\"SPID\"", (validator.field) = {,      int_gt: 0,      human_error: "SPID must be greater than zero",  }];
	*
	* @typedef  {Object}  AuthRoleGroup
	* @property {String}  UUID           
	* @property {Number}  SPID           Service Provider ID
	* @property {String}  Name           Name of this Role Group (editable by Service Provider user admin)
	* @property {StringSlice} Roles          List of Roles for this AuthRoleGroup
	* @property {Number}  CreatedAtNanos When this object was created
	* @property {String}  CreatedBy      Who this object was created by
	* @property {Number}  UpdatedAtNanos When this object was last updated
	* @property {String}  UpdatedBy      Who this object was last updated by
	* @property {Number}  DeletedAtNanos When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy      Who deleted this object
	*
	*/
	GetAuthRoleGroupByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Get)
		// Prepare URI params...
		let paramUUID = encodeURIComponent(req.UUID)
		return axios.get(`/v3/auth_role_group/${paramUUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAuthRoleGroup', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetAuthRoleGroupByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetAuthRoleGroupByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetAuthRoleGroupByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetAuthRoleGroupByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetAuthRoleGroupByUUID'))
			})
	},

	/**
	* RPC Method: GetAuthRoleGroupMemberByUUID
	* Description: 
	* HTTP Method: GET
	* API Path: /api/v3/auth_role_group/${req.AuthRoleGroupUUID}/auth_role_group/${req.UUID}
	* @param    {AuthRoleGroupMemberUUIDSearch} req The API payload object (AuthRoleGroupMemberUUIDSearch)
	* @return   {AuthRoleGroupMember} The API response object (AuthRoleGroupMember)
	*
	* @typedef  {Object}  AuthRoleGroupMemberUUIDSearch
	* @property {Number}  SPID              Service Provider ID
	* @property {String}  AuthRoleGroupUUID 
	* @property {String}  UUID              
	*
	* @typedef  {Object}  AuthRoleGroupMember
	* @property {String}  UUID              
	* @property {Number}  SPID              Service Provider ID
	* @property {String}  AuthRoleGroupUUID UUID of the AuthRole group
	* @property {ENUM}    IdentityProvider  The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID            Authentication Identifier
	* @property {Number}  CreatedAtNanos    When this object was created
	* @property {String}  CreatedBy         Who this object was created by
	* @property {Number}  UpdatedAtNanos    When this object was last updated
	* @property {String}  UpdatedBy         Who this object was last updated by
	* @property {Number}  DeletedAtNanos    When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy         Who deleted this object
	* @property {String}  DisplayName       
	*
	*/
	GetAuthRoleGroupMemberByUUID({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Get)
		// Prepare URI params...
		let paramAuthRoleGroupUUID = encodeURIComponent(req.AuthRoleGroupUUID)
		let paramUUID = encodeURIComponent(req.UUID)
		return axios.get(`/v3/auth_role_group/${paramAuthRoleGroupUUID}/auth_role_group/${paramUUID}`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAuthRoleGroupMember', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetAuthRoleGroupMemberByUUID ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetAuthRoleGroupMemberByUUID ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetAuthRoleGroupMemberByUUID ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetAuthRoleGroupMemberByUUID UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetAuthRoleGroupMemberByUUID'))
			})
	},

	/**
	* RPC Method: GetAuthRoleGroupMembersWithGroups
	* Description: 
	* HTTP Method: GET
	* API Path: /api/v3/auth_role_group_members_with_groups
	* @param    {AuthRoleGroupMembersWithGroupsRequest} req The API payload object (AuthRoleGroupMembersWithGroupsRequest)
	* @return   {AuthRoleGroupMembersWithGroupsResponse} The API response object (AuthRoleGroupMembersWithGroupsResponse)
	*
	* @typedef  {Object}  AuthRoleGroupMembersWithGroupsRequest
	* @property {SearchOptions[]} SearchOptions     
	* @property {Number}  SPID              Service Provider ID
	* @property {Boolean} IncludeDeleted    Include deleted records ?
	* @property {String}  AuthID            Filter by AuthID
	* @property {String}  AuthRoleGroupUUID Filter by AuthRoleGroupUUID
	*
	* @typedef  {Object}  AuthRoleGroupMembersWithGroupsResponse
	* @property {PageInfo} PageInfo                       PageInfo only needs the values ThisPageNumber && PageSize set
	* @property {AuthRoleGroupMemberWithGroups[]} AuthRoleGroupMembersWithGroups 
	*
	*/
	GetAuthRoleGroupMembersWithGroups({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request 
		return axios.get(`/v3/auth_role_group_members_with_groups`, { params: req }).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('GetAuthRoleGroupMembersWithGroups ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('GetAuthRoleGroupMembersWithGroups ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('GetAuthRoleGroupMembersWithGroups ERROR:', error)
					return Promise.reject(error)
				}
				console.log('GetAuthRoleGroupMembersWithGroups UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in GetAuthRoleGroupMembersWithGroups'))
			})
	},

	/**
	* RPC Method: UpdateAuthRoleGroup
	* Description: 
	* HTTP Method: PUT
	* API Path: /api/v3/auth_role_group/${req.UUID}
	* @param    {AuthRoleGroup} req The API payload object (AuthRoleGroup)
	* @return   {AuthRoleGroup} The API response object (AuthRoleGroup)
	*
	* @typedef  {Object}  AuthRoleGroup
	* @property {String}  UUID           
	* @property {Number}  SPID           Service Provider ID
	* @property {String}  Name           Name of this Role Group (editable by Service Provider user admin)
	* @property {StringSlice} Roles          List of Roles for this AuthRoleGroup
	* @property {Number}  CreatedAtNanos When this object was created
	* @property {String}  CreatedBy      Who this object was created by
	* @property {Number}  UpdatedAtNanos When this object was last updated
	* @property {String}  UpdatedBy      Who this object was last updated by
	* @property {Number}  DeletedAtNanos When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy      Who deleted this object
	*
	*/
	UpdateAuthRoleGroup({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Update)
		return axios.put(`/v3/auth_role_group/${req.UUID}`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAuthRoleGroup', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('UpdateAuthRoleGroup ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('UpdateAuthRoleGroup ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('UpdateAuthRoleGroup ERROR:', error)
					return Promise.reject(error)
				}
				console.log('UpdateAuthRoleGroup UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in UpdateAuthRoleGroup'))
			})
	},

	/**
	* RPC Method: UpdateAuthRoleGroupMember
	* Description: 
	* HTTP Method: PUT
	* API Path: /api/v3/auth_role_group/${req.AuthRoleGroupUUID}/auth_role_group_member/${req.UUID}
	* @param    {AuthRoleGroupMember} req The API payload object (AuthRoleGroupMember)
	* @return   {AuthRoleGroupMember} The API response object (AuthRoleGroupMember)
	*
	* @typedef  {Object}  AuthRoleGroupMember
	* @property {String}  UUID              
	* @property {Number}  SPID              Service Provider ID
	* @property {String}  AuthRoleGroupUUID UUID of the AuthRole group
	* @property {ENUM}    IdentityProvider  The Identity Provider (eg: GOOGLE|FACEBOOK|LOCAL|AD|etc)
	* @property {String}  AuthID            Authentication Identifier
	* @property {Number}  CreatedAtNanos    When this object was created
	* @property {String}  CreatedBy         Who this object was created by
	* @property {Number}  UpdatedAtNanos    When this object was last updated
	* @property {String}  UpdatedBy         Who this object was last updated by
	* @property {Number}  DeletedAtNanos    When this object was deleted (0 if not deleted)
	* @property {String}  DeletedBy         Who deleted this object
	* @property {String}  DisplayName       
	*
	*/
	UpdateAuthRoleGroupMember({ getters, rootGetters, commit }, req) {
		// Ensure request is not null or undefined 
		if (!req) { req = {} }
		// Make API request (CRUD Type: Update)
		return axios.put(`/v3/auth_role_group/${req.AuthRoleGroupUUID}/auth_role_group_member/${req.UUID}`, req).then(response => {
			// Success response
			if (!response.data) {
				return Promise.reject(Error('no response data'))
			}

			// Ensure we save the response in cache
			commit('mutSaveAuthRoleGroupMember', response.data)
			return Promise.resolve(response.data)
		})
			.catch(error => {
				// Error response received from API
				if (error.response) {
					// Server responded with a non-404 HTTP status code
					console.log('UpdateAuthRoleGroupMember ERROR Response:', error)
					return Promise.reject(error)
				} else if (error.request) {
					// Request was made but no response was received
					console.log('UpdateAuthRoleGroupMember ERROR making request:', error)
					return Promise.reject(error)
				}
				// Something went wrong in setting up the request
				if (error) {
					console.log('UpdateAuthRoleGroupMember ERROR:', error)
					return Promise.reject(error)
				}
				console.log('UpdateAuthRoleGroupMember UNKNOWN ERROR')
				return Promise.reject(Error('unknown error in UpdateAuthRoleGroupMember'))
			})
	},
};

export default {
	namespaced: true,
	state: initialState,
	getters,
	mutations,
	actions,
};